// Turkish translations
export const tr: Record<string, string> = {
  // Login
  'login.title': 'Cleandy',
  'login.subtitle': 'İşletme Yönetim Sistemi',
  'login.tagline': 'Kuru temizleme programı — İşletmeniz İçin Akıllı ve kolay kullanılan çözümler.',
  'login.tenantId': 'Şirket Kodu',
  'login.tenantPlaceholder': 'örn: cleanpro',
  'login.continue': 'Devam Et',
  'login.login': 'Giriş Yap',
  'login.loggingIn': 'Giriş yapılıyor...',
  'login.welcome': 'Hoş geldiniz, {name}',
  'login.loginFailed': 'Giriş başarısız',
  'login.pinMinLength': 'PIN en az 4 haneli olmalıdır',
  'login.invalidTenantId': 'Geçerli bir şirket kodu giriniz',
  'login.notMember': 'Henüz üye değil misiniz?',
  'login.startTrial': 'Ücretsiz Deneme Başlat',
  'login.changeTenant': 'Şirket Değiştir',
  'login.clear': 'Temizle',
  'login.systemInitializing': 'Sistem hazırlanıyor...',
  'login.usernameRequired': 'Kullanıcı adı gereklidir',
  'login.tenantNotFound': 'Firma kaydı bulunamadı: "{tenantId}"',
  'login.credentialsTitle': 'Giriş Bilgileri',
  'login.saveCredentialsNote': 'Bu bilgileri kaydedin!',
  'login.username': 'Kullanıcı Adı',
  'login.forget': 'Unut',
  'login.enterCredentials': 'Kullanıcı adı ve PIN girin',
  'login.usernamePlaceholder': 'patron, kasiyer...',

  // Main Menu
  'menu.carWash': 'Oto Yıkama',
  'menu.barber': 'Berber / Kuaför',
  'menu.dashboard': 'Dashboard',
  'menu.orderNew': 'Ürün Kayıt',
  'menu.deliveryList': 'Teslime hazır işler',
  'menu.delivery': 'Teslimat',
  'menu.driverPickup': 'Alınacak Siparişler',
  'menu.receipt': 'Fiş/Etiket Bas',
  
  // Definitions
  'menu.definitions': 'Tanımlar',
  'menu.customers': 'Müşteriler',
  'menu.products': 'Ürün Tanımları',
  'menu.pricing': 'Ürün Fiyat Tanımlamaları',
  'menu.tailoring': 'Terzi İşlemleri',
  'menu.attributes': 'Ürün Öz Nitelikleri',
  'menu.users': 'Kullanıcılar',
  'menu.productOrdering': 'Ürün Sıra Tanımları',
  'menu.discounts': 'İndirim Tanımları',
  
  // Settings
  'menu.settings': 'Ayarlar',
  'menu.generalSettings': 'Genel Ayarlar',
  'menu.permissions': 'Yetki Yönetimi',
  'menu.subscription': 'Abonelik',
  'menu.referral': 'Davet Et',
  'menu.payment': 'Ödeme',
  'menu.invoices': 'Fatura Yönetimi',
  'menu.expenses': 'Masraf Girişi',
  'menu.zReport': 'Z Raporu',
  'menu.reportsList': 'Fiş Listesi',
  'menu.reportsCharts': 'Grafik Raporları',
  'reportsList.totalReceipts': 'Toplam Fişler',
  'reportsList.registered': 'Kaydedilen',
  'reportsList.delivered': 'Teslim Edilen',
  'reportsList.totalRevenueExclCancelled': 'Toplam Ciro (İptaller Hariç)',
  'reportsList.activeOnly': 'Sadece Aktif Siparişler',
  'reportsList.receiptNumber': 'Fiş No',
  'reportsList.customer': 'Müşteri',
  'reportsList.phone': 'Telefon',
  'reportsList.date': 'Tarih',
  'reportsList.amount': 'Tutar',
  'reportsList.status': 'Durum',
  'reportsList.payment': 'Ödeme',
  'reportsList.searchPlaceholder': 'Fiş no, müşteri adı veya telefon...',
  'reportsList.noOrders': 'Sipariş bulunamadı',
  'reportsList.cancelled': 'İptal Edildi',
  'reportsList.reprint': 'Yeniden Yazdır',
  'menu.reportsAndAccounting': 'Raporlar & Muhasebe',
  'menu.systemAndCommunication': 'Sistem & İletişim',
  'menu.accountStatement': 'Cari Hesap Ekstresi',
  'menu.tickets': 'Destek Talepleri',
  'menu.support': 'Destek',
  'menu.profile': 'Profil',
  'menu.logout': 'Çıkış Yap',
  'menu.notifications': 'Bilgilendirme SMS/WhatsApp',
  'menu.whatsappConnection': 'WhatsApp Bağlantısı',
  'menu.smsConnection': 'SMS Bağlantısı',
  'menu.hardware': 'Donanım',
  
  // Navigation (for compatibility)
  'nav.logout': 'Çıkış Yap',
  'nav.user': 'Kullanıcı',
  
  // Dashboard
  'dashboard.title': 'Dashboard',
  'dashboard.todaySales': 'Bugünkü Satışlar',
  'dashboard.totalOrders': 'Toplam Siparişler',
  'dashboard.pendingDeliveries': 'İşlemdeki Teslimatlar',
  'dashboard.activeCustomers': 'Aktif Müşteriler',
  'dashboard.recentOrders': 'Son Siparişler',
  'dashboard.viewAll': 'Tümünü Gör',
  'dashboard.quickActions': 'Hızlı İşlemler',
  'dashboard.newOrder': 'Yeni Sipariş',
  'dashboard.newCustomer': 'Yeni Müşteri',
  'dashboard.deliveries': 'Teslimatlar',
  'dashboard.reports': 'Raporlar',
  'dashboard.today': 'Bugün',
  'dashboard.yesterday': 'Dün',
  'dashboard.week': 'Hafta',
  'dashboard.month': 'Ay',
  'dashboard.quarter': 'Çeyrek',
  'dashboard.year': 'Yıl',
  'dashboard.totalRevenue': 'Toplam Ciro',
  'dashboard.totalOrdersCard': 'Toplam Sipariş',
  'dashboard.totalPieces': 'Toplam Parça',
  'dashboard.cancelled': 'İptal Edilen',
  'dashboard.inProcess': 'İşlemde',
  'dashboard.inProcessDesc': 'İşlemde olan siparişler',
  'dashboard.ready': 'Hazır',
  'dashboard.readyDesc': 'Seçili dönemde hazır',
  'dashboard.delivered': 'Teslim Edildi',
  'dashboard.deliveredDesc': 'Seçili dönemde teslim',
  'dashboard.allTime': 'Tüm zamanlar',
  'dashboard.announcements': 'Duyurular',
  'dashboard.announcementAll': 'Genel',
  'dashboard.announcementPrivate': 'Özel',
  'dashboard.referral.title': 'Arkadaşını Davet Et',
  'dashboard.referral.desc': 'Davet ettiğin firma üye olunca 1 ay ekstra süre!',
  'dashboard.referral.button': 'Davet Et',
  
  // Order Entry
  'order.title': 'Yeni Sipariş',
  'order.customer': 'Müşteri',
  'order.selectCustomer': 'Müşteri Seç',
  'order.newCustomer': 'Yeni Müşteri',
  'order.products': 'Ürünler',
  'order.addProduct': 'Ürün Ekle',
  'order.selectProduct': 'Ürün Seç',
  'order.quantity': 'Adet',
  'order.price': 'Fiyat',
  'order.total': 'Toplam',
  'order.discount': 'İndirim',
  'order.subtotal': 'Ara Toplam',
  'order.tax': 'KDV',
  'order.grandTotal': 'Genel Toplam',
  'order.payment': 'Ödeme',
  'order.paymentMethod': 'Ödeme Yöntemi',
  'order.selectPaymentMethod': 'Ödeme Yöntemi Seçiniz',
  'order.cash': 'Nakit',
  'order.card': 'Kredi Kartı',
  'order.credit': 'Veresiye',
  'order.amountPaid': 'Ödenen Tutar',
  'order.remainingBalance': 'Kalan Bakiye',
  'order.deliveryDate': 'Teslim Tarihi',
  'order.notes': 'Notlar',
  'order.notesOptional': 'Notlar (Opsiyonel)',
  'order.notesPlaceholder': 'Ek bilgiler, özel istekler...',
  'order.newPrice': 'Yeni Fiyat',
  'order.totalWithQuantity': 'Toplam ({count} adet)',
  'order.createOrder': 'Sipariş Oluştur',
  'order.cancel': 'İptal',
  'order.discountRate': 'İskonto',
  'order.discountPercent': 'İskonto (%{percent})',
  'order.discountOptional': 'İskonto (Opsiyonel)',
  'order.enterDiscountRate': 'İskonto oranı girin (0-100):',
  'order.quickDiscount': 'Hızlı İskonto Butonları',
  'order.discountSummary': 'İskonto Özeti',
  'order.debt': 'Borç',
  'order.receivable': 'Alacak',
  'order.balanced': 'Dengeli',
  'order.totalDebt': 'Toplam Borç',
  'order.totalPayments': 'Toplam Ödemeler',
  'order.homeDeliveryShort': 'Adrese Teslim',
  'order.homeDeliveryIcon': '🏠 Adrese Teslim',
  'deliveryPage.changeToPickup': 'Şahsen Alacak',
  'deliveryPage.changeToPickupSuccess': 'Teslimat türü "Şahsen Alacak" olarak değiştirildi',
  'deliveryPage.changeToPickupError': 'Teslimat türü değiştirilemedi',
  'deliveryPage.changeToDelivery': 'Adrese Teslim',
  'deliveryPage.changeToDeliverySuccess': 'Teslimat türü "Adrese Teslim" olarak değiştirildi',
  'deliveryPage.changeDeliveryType': 'Teslim Türünü Değiştir',
  'order.addressIcon': '📍 Adres',
  'order.addressRequiredForDelivery': 'Adrese teslim için adres bilgisi gereklidir',
  'order.priceAndDiscountEdit': 'Fiyat ve İskonto Düzenleme',
  
  // Users
  'users.title': 'Kullanıcılar',
  'users.addNew': 'Yeni Kullanıcı',
  'users.name': 'Ad Soyad',
  'users.email': 'E-posta',
  'users.role': 'Rol',
  'users.pin': 'PIN',
  'users.permissions': 'Yetkiler',
  'users.allPermissions': 'Tüm Yetkiler',
  'users.permissionCount': '{count} yetki',
  'users.changePin': 'PIN Değiştir',
  'users.edit': 'Düzenle',
  'users.delete': 'Sil',
  'users.newUser': 'Yeni Kullanıcı',
  'users.editUser': 'Kullanıcı Düzenle',
  'users.editingUser': '{name} kullanıcısı düzenleniyor',
  'users.deleteUserTitle': 'Kullanıcıyı Sil',
  'users.deletingUser': '{name} kullanıcısını silmek istediğinize emin misiniz?',
  'users.pinCode': 'PIN Kodu (6 hane)',
  'users.selectRole': 'Rol seçin',
  'users.patron': 'Patron',
  'users.kasiyer': 'Kasiyer',
  'users.sofor': 'Şoför',
  'users.eleman': 'Eleman',
  'users.changePinTitle': 'PIN Kodu Değiştir',
  'users.newPin': 'Yeni PIN Kodu',
  'users.confirmPin': 'PIN Kodunu Onayla',
  'users.pinMismatch': 'PIN kodları eşleşmiyor',
  'users.pinRequired': 'PIN kodu gerekli',
  'users.pinLength': 'PIN kodu 6 hane olmalıdır',
  'users.changingPinFor': '{name} kullanıcısının PIN kodu değiştiriliyor',
  
  // Products
  'products.title': 'Ürün Tanımları',
  'products.addNew': 'Yeni Ürün',
  'products.category': 'Kategori',
  'products.name': 'Ürün Adı',
  'products.price': 'Fiyat',
  'products.color': 'Renk',
  'products.active': 'Aktif',
  'products.actions': 'İşlemler',
  'products.search': 'Ürün Ara...',
  'products.noProducts': 'Ürün bulunamadı',
  'products.noCategoryProducts': 'Bu kategoride ürün bulunamadı',
  'products.emptyCart': 'Sepet boş',
  
  // Service Types
  'service.tailor': 'Terzi',
  'service.dryCleaning': 'Kuru Temizleme',
  'service.washing': 'Yıkama',
  'service.ironing': 'Ütü',
  'service.dyeing': 'Boyama',
  'service.shoeShine': 'Lostra',
  'service.carpetWashing': 'Halı Yıkama',
  'service.sofaWashing': 'Koltuk Yıkama',
  'service.carWash': 'Oto Yıkama',
  'service.barber': 'Berber / Kuaför',
  'service.carpet': 'Halı',
  'service.tailoring': 'Terzi Tadilat',
  'service.carpetWashing': 'Halı Yıkama',
  'service.selectService': 'Hizmet seçiniz',
  'service.addToCart': 'Sepete Ekle',
  'service.total': 'Toplam',
  
  // Service Abbreviations (for receipts)
  'service.dryCleaningShort': 'KT',
  'service.ironingShort': 'ÜT',
  'service.dyeingShort': 'BY',
  'service.washingShort': 'YK',
  'service.tailoringShort': 'TRZ',
  'service.shoeShineShort': 'LST',
  'service.carpetShort': 'HLY',
  
  // Order Status
  'status.pending': 'İşlemde',
  'status.ready': 'Hazır',
  'status.delivered': 'Teslim Edildi',
  'status.cancelled': 'İptal Edildi',
  'status.pickup_pending': 'Alınacak',
  'status.pickup_in_progress': 'Alınıyor',
  'status.received': 'Alındı',
  
  // Order Create Page
  'orderCreate.cart': 'Sepet',
  'orderCreate.totalPieces': 'Toplam Parça',
  'orderCreate.plannedDelivery': 'Planlanan Teslim',
  'orderCreate.payment': 'Ödeme',
  'orderCreate.save': 'Kaydet',
  'orderCreate.continue': 'Devam Et',
  'orderCreate.allCategories': 'Tümü',
  
  // Area Calculation Dialog
  'areaCalculation.title': 'Alan Hesaplama',
  'areaCalculation.carpetCount': '🔢 Halı Adedi',
  'areaCalculation.carpetCountPlaceholder': 'Kaç adet halı?',
  'areaCalculation.directInput': '📏 Doğrudan m² Gir',
  'areaCalculation.totalSqM': '📏 Toplam m² ({count} adet halı için)',
  'areaCalculation.exampleSqM': 'Örn: 12.5',
  'areaCalculation.or': 'VEYA',
  'areaCalculation.width': 'En (m)',
  'areaCalculation.height': 'Boy (m)',
  'areaCalculation.exampleNumber': 'Örn: 4',
  'areaCalculation.calculatedArea': 'Hesaplanan Alan:',
  'areaCalculation.perCarpet': 'Halı başına',
  'areaCalculation.total': 'Toplam',
  'areaCalculation.continue': 'Devam Et',
  'orderCreate.selectCustomer': 'Müşteri Seç',
  'orderCreate.selectCustomerPlaceholder': 'Müşteri seçiniz',
  'orderCreate.change': 'Değiştir',
  'orderCreate.select': 'Seç',
  'orderCreate.balance': 'Bakiye',
  'orderCreate.searchCustomer': 'Ad, telefon veya adres ile ara... (örnek: ali+5551234567)',
  'orderCreate.newCustomer': 'Yeni Müşteri',
  'orderCreate.customerName': 'Ad Soyad',
  'orderCreate.customerPhone': 'Telefon',
  'orderCreate.customerEmail': 'E-posta',
  'orderCreate.customerAddress': 'Adres',
  'orderCreate.addCustomer': 'Müşteri Ekle',
  
  // Placeholders - Customer Form
  'placeholder.customerName': 'Örn: AHMET YILMAZ',
  'placeholder.customerPhone': 'Örn: 0555 123 45 67',
  'placeholder.customerEmail': 'Örn: ahmet@example.com',
  'placeholder.customerAddress': 'Örn: KADIKÖY, İSTANBUL',
  'placeholder.customerNotes': 'Örn: VIP MÜŞTERİ',
  
  'orderCreate.customer': 'Müşteri',
  'orderCreate.serviceType': 'Hizmet Tipi',
  'orderCreate.clickToSelect': 'Seçmek için tıklayın',
  'orderCreate.deliveryDate': 'Teslim Tarihi',
  'orderCreate.details': 'Detay',
  'orderCreate.itemDetails': 'Detaylar',
  'orderCreate.tailoringOperations': 'Terzi İşlemleri',
  'orderCreate.tailoringTitle': 'Terzi İşlemleri',
  'orderCreate.selectOperation': 'İşlem seçiniz (fiyatlar otomatik eklenecektir)',
  'orderCreate.selectedOperations': 'Seçilen İşlemler',
  'orderCreate.discount': 'İskonto',
  'orderCreate.discountLabel': 'İskonto (%)',
  'orderCreate.debt': 'Borç',
  'orderCreate.credit': 'Alacak',
  'orderCreate.homeDelivery': 'Adrese Teslim',
  'order.homeDelivery': 'Adrese Teslim',
  'orderCreate.homeDeliveryAddress': 'Adres',
  'orderCreate.addressRequired': 'Adres gerekli!',
  'orderCreate.pickupFromAddress': 'Şoför adresten alacak',
  'orderCreate.subtotal': 'Ara Toplam',
  'orderCreate.grandTotal': 'Genel Toplam',
  
  // Pricing Page
  'pricing.title': 'Fiyat Tanımları',
  'pricing.search': 'Ürün Ara...',
  'pricing.product': 'Ürün',
  'pricing.dryCleaning': 'Kuru Temizleme',
  'pricing.washing': 'Yıkama',
  'pricing.ironing': 'Ütü',
  'pricing.dyeing': 'Boyama',
  'pricing.tailoring': 'Terzi Tadilat',
  'pricing.shoeShine': 'Lostra',
  'pricing.action': 'İşlem',
  'pricing.save': 'Kaydet',
  'pricing.enterPrice': 'Fiyat girin',
  'pricing.percent': 'Yüzde',
  'pricing.amount': 'Tutar',
  'pricing.saving': 'Kaydediliyor',
  'pricing.pricesSaved': 'Fiyatlar kaydedildi',
  'pricing.pricesSaveError': 'Fiyatlar kaydedilemedi',
  'pricing.noProducts': 'Ürün bulunamadı',
  'pricing.loadError': 'Ürünler yüklenemedi',
  
  // Tailoring Page
  'tailoring.title': 'Terzi İşlemleri',
  'tailoring.addNew': 'Yeni İşlem',
  'tailoring.pacaBoyu': 'Koltuk Dikimi',
  'tailoring.belAyarı': 'Bel Ayarı',
  'tailoring.kolBoyu': 'Kol Boyu',
  'tailoring.fermuarDegisimi': 'Fermağar Değişimi',
  'tailoring.dugmeDikme': 'Düğme Dikme',
  'tailoring.sokukDikimi': 'Şokuk Dikimi',
  'tailoring.yama': 'Yama',
  'tailoring.astarDegisimi': 'Astar Değişimi',
  'tailoring.omuzAyarı': 'Omuz Ayarı',
  'tailoring.cepDikimi': 'Cep Dikimi',
  'tailoring.addCustom': 'Özel İşlem Ekle',
  'tailoring.operationName': 'İşlem Adı',
  'tailoring.price': 'Fiyat',
  'tailoring.icon': 'İkon',
  'tailoring.save': 'Kaydet',
  'tailoring.cancel': 'İptal',
  
  // Attributes Page
  'attributes.title': 'Ürün Öz Nitelikleri',
  'attributes.colors': 'Renkler',
  'attributes.stains': 'Leke Tipleri',
  'attributes.damages': 'Hasar Tipleri',
  'attributes.add': 'Ekle',
  
  // Permissions Page
  'permissions.title': 'Yetki Yönetimi',
  'permissions.subtitle': 'Patron ve kasiyer rollerinin yetkilerini belirleyin',
  'permissions.about': 'Yetki Yönetimi Hakkında',
  'permissions.patronInfo': '<strong>Patron:</strong> Tüm sistem yetkilerine sahip olan ana yönetici rolüdür.',
  'permissions.cashierInfo': '<strong>Kasiyer:</strong> Günlük operasyonlar için sınırlı yetkilere sahip kullanıcı rolüdür.',
  'permissions.saveSuccess': 'Yetkiler kaydedildi',
  'permissions.saveError': 'Yetkiler kaydedilemedi',
  'permissions.patron': 'Patron',
  'permissions.cashier': 'Kasiyer',
  'permissions.patronRole': 'Tam yetkili yönetici',
  'permissions.cashierRole': 'Sınırlı yetkili kullanıcı',
  'permissions.activePermissions': 'Aktif Yetkiler:',
  'permissions.selectAllPatron': 'Patron Tümünü Seç',
  'permissions.deselectAllPatron': 'Patron Tümünü Kaldır',
  'permissions.selectAllCashier': 'Kasiyer Tümünü Seç',
  'permissions.deselectAllCashier': 'Kasiyer Tümünü Kaldır',
  'permissions.saving': 'Kaydediliyor...',
  'permissions.permissionList': 'Yetki Listesi',
  'permissions.infoTitle': 'Yetki Yönetimi Hakkında',
  'permissions.infoText1': 'Tüm sistem yetkilerine sahip olan ana yönetici rolüdür.',
  'permissions.infoText2': 'Günlük operasyonlar için sınırlı yetkilere sahip kullanıcı rolüdür.',
  'permissions.infoText3': 'Değişiklikler kaydedilene kadar geçerli olmayacaktır.',
  'permissions.infoText4': 'Her rol için yetkiler özelleştirilebilir.',
  
  // Driver Dashboard Page
  'driver.title': 'Şoför Paneli',
  'driver.todayRevenue': 'Bugünkü Ciro',
  'driver.totalPieces': 'Toplam Parça',
  'driver.pending': 'İşlemde',
  'driver.ready': 'Hazır',
  'driver.pickup': 'Ürün Alma',
  
  // Subscription Page
  'subscription.title': 'Abonelik Planları',
  'subscription.currentPlan': 'Mevcut Planınız',
  'subscription.upgradePlan': 'Yükselt',
  'subscription.downgradePlan': 'Küçült',
  'subscription.choosePlan': 'Plan Seç',
  'subscription.billingCycle': 'Ödeme Döngüsü',
  'subscription.monthly': 'Aylık',
  'subscription.yearly': 'Yıllık',
  'subscription.perMonth': '/ay',
  'subscription.perYear': '/yıl',
  'subscription.plusVAT': '+ KDV',
  'subscription.save': '%{percent} Tasarruf',
  'subscription.mostPopular': 'En Popüler',
  'subscription.freeTrial': '{months} ay ücretsiz',
  'subscription.featuresIncluded': 'Özellikler:',
  
  // Plan Names & Descriptions
  'subscription.starter': 'Starter',
  'subscription.starterDesc': 'Küçük işletmeler için ideal',
  'subscription.professional': 'Professional',
  'subscription.professionalDesc': 'Büyüyen işletmeler için',
  'subscription.enterprise': 'Enterprise',
  'subscription.enterpriseDesc': 'Kurumsal çözümler',
  
  // Plan Features
  'subscription.maxReceipts': 'Maksimum {count} fiş/ay',
  'subscription.maxUsers': '{count} kullanıcı hesabı',
  'subscription.whatsappCredits': '🎁 {count} WhatsApp kontör hediye',
  'subscription.basicReports': 'Temel raporlar',
  'subscription.advancedReports': 'Gelişmiş raporlar',
  'subscription.customReports': 'Özel raporlar',
  'subscription.whatsappIntegration': 'WhatsApp entegrasyonu',
  'subscription.supportTicket': 'Destek ticket süresi: {hours} saat',
  'subscription.supportTicketBusiness': 'Destek ticket süresi: {hours} saat (mesai saatinde)',
  'subscription.accountManagement': 'Cari hesap yönetimi',
  'subscription.driverApp': 'Mobil şoför uygulaması',
  'subscription.prioritySupport': 'Öncelikli destek',
  'subscription.managerApp': 'Mobil uyumlu patron ekranı',
  'subscription.odealPOS': 'Ödeal POS entegrasyonu (isteğe bağlı)',
  'subscription.unlimitedUsers': 'Sınırsız kullanıcı',
  'subscription.branchesIncluded': '2 şubeye kadar dahil',
  'subscription.branchCashManagement': 'Şubeye özel kasa yönetimi',
  'subscription.crossBranchDelivery': 'Çapraz şube teslimat',
  'subscription.enterpriseOnlyTitle': 'Enterprise Planı Gerekli',
  'subscription.enterpriseOnlyDesc': 'Şube yönetimi sadece Enterprise planında kullanılabilir. Birden fazla şubeyi yönetmek, şubeye özel kasa ve çapraz şube teslimat için Enterprise\'a geçin.',
  'subscription.upgradeToEnterprise': 'Enterprise\'a Geç',

  // Payment
  'subscription.paymentTitle': 'Ödemeyi Tamamla',
  'subscription.planSelection': 'Seçilen Plan',
  'subscription.billingPeriod': 'Fatura Dönemi',
  'subscription.month': 'ay',
  'subscription.year': 'yıl',
  'subscription.subtotal': 'Ara Toplam',
  'subscription.tax': 'KDV (%{rate})',
  'subscription.total': 'Toplam',
  'subscription.couponCode': 'Kupon Kodu',
  'subscription.applyCoupon': 'Uygula',
  'subscription.removeCoupon': 'Kaldır',
  'subscription.discount': 'İndirim',
  'subscription.invalidCoupon': 'Geçersiz kupon kodu',
  'subscription.couponVerificationFailed': 'Kupon doğrulanamadı',
  'subscription.couponRemoved': 'Kupon kaldırıldı',
  
  // Billing Information
  'subscription.billingInfo': 'Fatura Bilgileri',
  'subscription.companyName': 'Ünvan',
  'subscription.companyNamePlaceholder': 'Firma ünvanı giriniz',
  'subscription.taxNumber': 'Vergi Numarası',
  'subscription.taxNumberPlaceholder': 'Vergi numarası giriniz',
  'subscription.phone': 'Telefon',
  'subscription.phonePlaceholder': 'Telefon numarası giriniz',
  'subscription.address': 'Adres',
  'subscription.addressPlaceholder': 'Fatura adresi giriniz',
  'subscription.corporateInvoice': 'Kurumsal Fatura',
  'subscription.individualInvoice': 'Bireysel Fatura',
  
  // Payment Methods
  'subscription.paymentMethod': 'Ödeme Yöntemi',
  'subscription.creditCard': 'Kredi Kartı',
  'subscription.bankTransfer': 'Banka Havalesi',
  'subscription.cardNumber': 'Kart Numarası',
  'subscription.cardNumberPlaceholder': 'Kart numarası giriniz',
  'subscription.expiryDate': 'Son Kullanma',
  'subscription.cvc': 'CVC',
  
  // Actions & Messages
  'subscription.completePayment': 'Ödemeyi Tamamla',
  'subscription.processing': 'İşleniyor...',
  'subscription.redirectingToPayment': 'Ödeme sayfasına yönlendiriliyorsunuz...',
  'subscription.paymentSuccess': '✅ Ödeme başarılı! Aboneliğiniz aktif edildi.',
  'subscription.paymentCompleted': '🎉 Ödeme başarıyla tamamlandı!',
  'subscription.paymentCancelled': '❌ Ödeme iptal edildi.',
  'subscription.paddleTestCards': 'Test kartları console\'a yazdırıldı! (F12)',
  'subscription.sandboxTestCards': '🎴 TEST KARTLARI (SANDBOX)',
  'subscription.successfulPaymentCards': '✅ BAŞARILI ÖDEME TEST KARTLARI:',
  'subscription.failedPaymentCards': '❌ HATALI ÖDEME TEST KARTLARI:',
  'subscription.invalidCard': '📌 Geçersiz Kart:',
  'subscription.sandboxOnly': '📝 NOT: Bu kartlar sadece Sandbox ortamında çalışır!',
  
  // Errors
  'subscription.enterCompanyName': 'Ünvan giriniz',
  'subscription.enterPhone': 'Telefon numarası giriniz',
  'subscription.enterTaxNumber': 'Vergi numarası giriniz',
  'subscription.selectPackage': 'Lütfen bir paket seçiniz',
  'subscription.selectPlan': 'Lütfen bir plan seçiniz',
  'subscription.paddleNotLoaded': 'Paddle SDK henüz yüklenmedi. Lütfen sayfayı yenileyin.',
  'subscription.paymentError': 'Ödeme hatası: ',
  'subscription.paymentCreationFailed': 'Ödeme işlemi oluşturulamadı. Lütfen konsol loglarını kontrol edin.',
  'subscription.paddleConfigurationMissing': '⚠️ Paddle Yapılandırması Eksik!',
  'subscription.paddleDashboardRequired': '⚠️ Paddle Dashboard Yapılandırması Gerekli!',
  'subscription.paddleApiNotConfigured': 'Paddle API anahtarı yapılandırılmamış. Lütfen yöneticinizle iletişime geçin.',
  
  // Cancel Subscription
  'subscription.cancelConfirm': 'Aboneliğinizi iptal etmek istediğinizden emin misiniz? Dönem sonuna kadar hizmetiniz devam edecektir.',
  'subscription.cancelSuccess': '✅ Abonelik iptal edildi. Dönem sonuna kadar hizmetiniz devam edecektir.',
  'subscription.cancelFailed': 'İptal başarısız',
  
  // Region & Currency
  'subscription.region.turkey': '🇹🇷 Türkiye',
  'subscription.region.europe': '🇪🇺 Avrupa',
  'subscription.region.other': '🌎 Diğer',
  
  // Status
  'subscription.status': 'Durum',
  'subscription.active': 'Aktif',
  'subscription.sandboxMode': '🧪 SANDBOX (Test Modu)',
  'subscription.liveMode': ' LIVE (Canlı Ortam)',
  'subscription.paddleActive': 'Aktif',
  'subscription.paddleConfigured': '✅ Evet',
  'subscription.paddleNotConfigured': '❌ Hayır',
  
  // WhatsApp Credits
  'subscription.whatsappCreditsTitle': 'WhatsApp Kontör',
  'subscription.whatsappCreditsPackages': 'Kontör Paketleri',
  'subscription.whatsappCurrentBalance': 'Mevcut Bakiye',
  'subscription.whatsappCreditsAmount': '{count} Kontör',
  'subscription.whatsappPurchaseCredits': 'Kontör Satın Al',
  
  // Invoices Page
  'invoices.title': 'Fatura Yönetimi',
  'invoices.subtitle': 'Abonelik faturalarınızı görüntüleyin ve indirin',
  
  // Expenses Page
  'expenses.title': 'Masraf Girişi',
  'expenses.addNew': 'Yeni Masraf',
  'expenses.total': 'Toplam Masraf',
  'expenses.totalToday': 'Bugünkü Toplam Masraf',
  'expenses.deletePermission': 'ℹ️ Masraf silme yetkisi sadece patron rolüne aittir.',
  'expenses.description': 'Açıklama',
  'expenses.amount': 'Tutar',
  'expenses.category': 'Kategori',
  'expenses.noExpenses': 'Bugün masraf kaydı yok',
  'expenses.newExpense': 'Yeni Masraf',
  'expenses.descriptionLabel': 'Açıklama *',
  'expenses.amountLabel': 'Tutar (₺) *',
  'expenses.categoryLabel': 'Kategori *',
  'expenses.categoryPlaceholder': 'Kategori seçin...',
  'expenses.deleteTitle': 'Masrafı Sil',
  'expenses.deleteConfirm': 'Bu masrafı silmek istediğinize emin misiniz?',
  'expenses.descriptionField': 'Açıklama:',
  'expenses.categoryField': 'Kategori:',
  'expenses.amountField': 'Tutar:',
  'expenses.dateField': 'Tarih:',
  'expenses.cancel': 'İptal',
  'expenses.yesDelete': 'Evet, Sil',
  'expenses.deleting': 'Siliniyor...',
  'expenses.saved': 'Masraf kaydedildi',
  'expenses.saveError': 'Masraf kaydedilemedi',
  'expenses.deleted': 'Masraf silindi',
  'expenses.deleteError': 'Masraf silinemedi',
  'expenses.loadError': 'Masraflar yüklenemedi',
  'expenses.dateFilter': 'Tarih Filtresi',
  'expenses.showDateFilter': 'Tarih Aralığı Seç',
  'expenses.startDate': 'Başlangıç Tarihi',
  'expenses.endDate': 'Bitiş Tarihi',
  'expenses.applyFilter': 'Filtrele',
  'expenses.clearFilter': 'Temizle',
  'expenses.activeFilter': 'Aktif Filtre',
  'expenses.filterApplied': 'Tarih filtresi uygulandı',
  'expenses.filterCleared': 'Filtre temizlendi',
  'expenses.selectBothDates': 'Lütfen başlangıç ve bitiş tarihlerini seçin',
  'expenses.canOnlyDeleteToday': 'Sadece bugün girdiğiniz masrafları silebilirsiniz.',
  'expenses.myBranch': 'Şubeniz',
  'expenses.noBranchSelected': '— Şube seçilmedi —',
  'expenses.branchSelect': 'Şube seç',
  'expenses.excelError': 'Excel oluşturulamadı',
  'expenses.exportExcel': 'Excel',
  'expenses.records': 'kayıt',
  'expenses.categoryBy': 'Kategoriye Göre',
  'expenses.allTypes': 'Tüm Tipler',
  'expenses.noBranch': 'Şubesiz',
  'expenses.allBranches': 'Tüm Şubeler',
  'expenses.expenseType': 'Masraf Tipi',
  
  // Z Report Page
  'zReport.title': 'Z Raporu',
  'zReport.loadError': 'Rapor yüklenemedi',
  'zReport.loading': 'Yükleniyor...',
  'zReport.excelDownloaded': 'Excel dosyası indirildi',
  'zReport.excelError': 'Excel dosyası oluşturulamadı',
  'zReport.singleDay': 'Tek Gün',
  'zReport.dateRange': 'Tarih Aralığı',
  'zReport.startDate': 'Başlangıç',
  'zReport.endDate': 'Bitiş',
  'zReport.totalOrders': 'Toplam Sipariş',
  'zReport.totalRevenue': 'Toplam Ciro',
  'zReport.paymentMethods': 'Ödeme Yöntemleri',
  'zReport.cash': 'Nakit',
  'zReport.creditCard': 'Kredi Kartı',
  'zReport.mealCard': 'Yemek Kartı',
  'zReport.account': 'Cari Hesap',
  'zReport.onDelivery': 'Teslimatta Ödeme',
  'zReport.collectionDetails': 'Tahsilat Detayı',
  'zReport.orderCollections': 'Sipariş Tahsilatları',
  'zReport.accountCollections': 'Cari Hesap Tahsilatları',
  'zReport.cariCollection': 'Cari Tahsilat',
  'zReport.paymentDetails': 'Tahsilat Detayı',
  'zReport.todayRegistrations': 'Bugünki Kayıtlar',
  'zReport.bankTransfer': 'Havale',
  'zReport.totalCollection': 'Toplam Tahsilat',
  'zReport.expenses': 'Masraflar',
  'zReport.noExpenses': 'Masraf kaydı yok',
  'zReport.totalExpenses': 'Toplam Masraf',
  'zReport.cancelledReceipts': 'İptal Edilen Fişler',
  'zReport.reason': 'Neden',
  'zReport.noCancelled': 'İptal edilen fiş yok',
  'zReport.totalCancelled': 'Toplam İptal ({count} Fiş)',
  'zReport.cashRegister': 'Kasa Hesabı',
  'zReport.startingCash': 'Başlangıç Parası',
  'zReport.dailyCashIncome': 'Günlük Nakit Gelir',
  'zReport.cashToDeliver': 'Teslim Edilecek Nakit',
  'zReport.deliveryCash': 'Teslimde Alınan Nakit',
  'zReport.deliveryCard': 'Teslimde Alınan Kredi Kartı',
  'zReport.serviceBreakdown': 'Hizmet Bazlı Parça Sayısı (Girişler)',
  'zReport.collectedItems': 'Tahsilatı Yapılanlar',
  'zReport.infoNote': 'Bilgi Amaçlıdır',
  
  // Z-Report (added keys)
  'zReport.cancelledOrders': 'İptal Sipariş',
  'zReport.paidAtRegister': 'Kayıtta Ödenen',
  'zReport.paidAtDelivery': 'Teslimde Ödenen',
  'zReport.incoming': 'Giren',
  'zReport.outgoing': 'Çıkan',
  'zReport.totalRegistered': 'Kayıt Edilen Toplam',
  'zReport.todayOrders': "Bugünkü Siparişler",
  'zReport.registrationAndDelivery': 'Kayıt + Teslim',
  'zReport.orderPaidAtRegister': 'Kayıtta Ödenen Sipariş',
  'zReport.orderPaidAtDelivery': 'Teslimde Ödenen Sipariş',
  'zReport.cashCalculation': '(Başlangıç + Bugünkü Nakit - Giderler)',
  'zReport.discountNotReflected': 'Tutarlar indirim uygulanmış net fiyatlar üzerinden hesaplanmaktadır.',

  // Account Statement Page (Cari Hesap Ekstresi)
  'accountStatement.title': 'Cari Hesap Ekstresi',
  'accountStatement.subtitle': 'Müşteri bazında borç-alacak takibi',
  'accountStatement.selectCustomer': 'Müşteri Seçin',
  'accountStatement.customerPlaceholder': 'Müşteri seçiniz...',
  'accountStatement.searchCustomer': 'İsim, telefon veya adres ile ara...',
  'accountStatement.noCustomerSelected': 'Lütfen bir müşteri seçin',
  'accountStatement.currentBalance': 'Güncel Bakiye',
  'accountStatement.totalDebt': 'Toplam Borç',
  'accountStatement.totalPayments': 'Toplam Ödeme',
  'accountStatement.transactions': 'Hareketler',
  'accountStatement.noTransactions': 'Bu müşteri için işlem kaydı bulunamadı',
  'accountStatement.date': 'Tarih',
  'accountStatement.description': 'Açıklama',
  'accountStatement.debit': 'Borç',
  'accountStatement.credit': 'Alacak',
  'accountStatement.balance': 'Bakiye',
  'accountStatement.order': 'Sipariş',
  'accountStatement.payment': 'Ödeme',
  'accountStatement.loadError': 'Cari hesap yüklenemedi',
  'accountStatement.addPayment': 'Ödeme Ekle',
  'accountStatement.paymentAmount': 'Ödeme Tutarı',
  'accountStatement.paymentMethod': 'Ödeme Yöntemi',
  'accountStatement.paymentNotes': 'Açıklama (İsteğe Bağlı)',
  'accountStatement.recordPayment': 'Ödeme Kaydet',
  'accountStatement.paymentSaved': 'Ödeme kaydedildi',
  'accountStatement.paymentError': 'Ödeme kaydedilemedi',
  'accountStatement.selectCustomerFirst': 'Önce müşteri seçiniz',
  'accountStatement.exportStatement': 'Ekstreyi İndir',
  'accountStatement.exportStatementPDF': 'PDF İndir',
  'accountStatement.noCustomersFound': 'Müşteri bulunamadı',
  'accountStatement.searchHint': 'Müşteri aramak için en az 2 karakter girin',
  'accountStatement.selectedCustomer': 'Seçili Müşteri',
  'accountStatement.changeCustomer': 'Müşteriyi Değiştir',
  
  // Notification Settings Page
  'notifications.title': 'Bilgilendirme SMS/WhatsApp',
  'notifications.subtitle': 'SMS ve WhatsApp bildirim ayarlarını düzenleyin',
  
  // WhatsApp Connection Page
  'whatsapp.title': 'WhatsApp Bağlantısı',
  'whatsapp.subtitle': 'WhatsApp Business API bağlantınızı yönetin',
  'whatsapp.connectionStatus': 'Bağlantı Durumu',
  'whatsapp.disconnected': 'Bağlı Değil',
  'whatsapp.notConnectedMessage': 'WhatsApp hesabınız henüz bağlanmadı',
  'whatsapp.connectWithQR': 'QR Kod ile Bağlan',
  'whatsapp.importantInfo': 'Önemli Bilgiler',
  'whatsapp.info1': '1. QR kodu telefonunuzun WhatsApp uygulaması ile tarayın',
  'whatsapp.info2': '2. Bağlantı kurulduktan sonra otomatik mesaj gönderebilirsiniz',
  'whatsapp.info3': '3. Bağlantıyı koparmak için WhatsApp ayarlarından çıkış yapın',
  'whatsapp.info4': '4. QR kod 60 saniye sonra otomatik olarak yenilenir',
  'whatsapp.generateQR': 'QR Kod Oluştur',
  
  // Profile Page
  'profile.subscriptionBilling': 'Abonelik ve Faturalama',
  
  // Error Boundary
  'errorBoundary.unknownError': 'Bir hata oluştu',
  'errorBoundary.pageNotFound': 'Sayfa Bulunamadı',
  'errorBoundary.pageNotFoundDetails': 'Aradığınız sayfa mevcut değil veya taşınmış olabilir.',
  'errorBoundary.unauthorized': 'Yetkisiz Erişim',
  'errorBoundary.unauthorizedDetails': 'Bu sayfaya erişim yetkiniz bulunmamaktadır.',
  'errorBoundary.forbidden': 'Erişim Reddedildi',
  'errorBoundary.forbiddenDetails': 'Bu işlemi gerçekleştirmek için yetkiniz yeterli değil.',
  'errorBoundary.serverError': 'Sunucu Hatası',
  'errorBoundary.serverErrorDetails': 'Sunucu tarafında bir hata oluştu. Lütfen daha sonra tekrar deneyin.',
  'errorBoundary.technicalDetails': 'Teknik Detaylar',
  'errorBoundary.reload': 'Sayfayı Yenile',
  'errorBoundary.goHome': 'Ana Sayfaya Dön',
  'errorBoundary.persistentIssue': 'Sorun devam ederse lütfen destek ekibiyle iletişime geçin.',
  
  // Error Messages (Backend)
  'error.phoneAlreadyExists': 'Bu telefon numarası zaten kayıtlı! Lütfen başka bir telefon numarası kullanın.',
  'error.customerNotCreated': 'Müşteri oluşturulamadı',
  'error.customerNotUpdated': 'Müşteri güncellenemedi',
  'error.customerNotFound': 'Müşteri bulunamadı',
  'error.customerNotDeleted': 'Müşteri silinemedi',
  'error.customersNotLoaded': 'Müşteriler yüklenemedi',
  'error.orderNotCreated': 'Sipariş oluşturulamadı',
  'error.orderNotUpdated': 'Sipariş güncellenemedi',
  'error.ordersNotLoaded': 'Siparişler yüklenemedi',
  'error.productNotCreated': 'Ürün oluşturulamadı',
  'error.productNotUpdated': 'Ürün güncellenemedi',
  'error.productsNotLoaded': 'Ürünler yüklenemedi',
  'error.userNotCreated': 'Kullanıcı oluşturulamadı',
  'error.userNotUpdated': 'Kullanıcı güncellenemedi',
  'error.usersNotLoaded': 'Kullanıcılar yüklenemedi',
  'error.expenseNotCreated': 'Masraf oluşturulamadı',
  'error.expenseNotDeleted': 'Masraf silinemedi',
  'error.expensesNotLoaded': 'Masraflar yüklenemedi',
  'error.paymentFailed': 'Ödeme başarısız',
  'error.tenantIdRequired': 'Oturum bilgisi gerekli',
  'error.tenantIdRequiredLogin': 'Oturum bilgisi gerekli. Lütfen giriş yapın.',
  'error.unauthorized': 'Yetkisiz erişim',
  'error.forbidden': 'Bu işlem için yetkiniz yok',
  'error.serverError': 'Sunucu hatası',
  'error.invalidRequest': 'Geçersiz istek',
  'error.databaseError': 'Veritabanı hatası',
  'error.unknownError': 'Bilinmeyen bir hata oluştu',
  
  // Common Form Fields
  'form.color': 'Renk',
  'form.stain': 'Leke',
  'form.damage': 'Hasar',
  'form.notes': 'Notlar',
  'form.area': 'Alan',
  
  // Stain Types
  'stain.blood': 'Kan',
  'stain.oil': 'Yağ',
  'stain.ink': 'Mürekkep',
  'stain.teaCoffee': 'Çay/Kahve',
  'stain.fruit': 'Meyve',
  'stain.rust': 'Pas',
  'stain.paint': 'Boya',
  'stain.mud': 'Çamur',
  'stain.salt': 'Tuz',
  'stain.none': 'Yok',
  'stain.status': 'Leke Durumu',
  'stain.multiple': 'Leke Durumu (Birden fazla seçilebilir)',
  'damage.multiple': 'Hasar Durumu (Birden fazla seçilebilir)',
  'stain.other': 'Diğer leke...',
  'damage.other': 'Diğer hasar...',
  'stain.pembe': 'Pembe',
  
  // Damage Types
  'damage.hole': 'Delik',
  'damage.tear': 'Yırtık',
  'damage.burn': 'Yanık',
  'damage.fray': 'Yıpranma',
  'damage.button': 'Düğme Sorunu',
  'damage.stain': 'Leke',
  'damage.color': 'Renk Atması',
  'damage.buttonMissing': 'Düğme Eksik',
  'damage.zipper': 'Fermuar',
  'damage.fade': 'Solma',
  'damage.worn': 'Aşınma',
  'damage.seam': 'Dikiş',
  'damage.lining': 'Astar',
  'damage.none': 'Yok',
  'damage.delik': 'Delik',
  'damage.pembe': 'Pembe Leke',
  
  // Delivery
  'delivery.title': 'Teslimat Yönetimi',
  'delivery.pending': 'İşlemde',
  'delivery.ready': 'Hazır',
  'delivery.delivered': 'Teslim Edildi',
  'delivery.orderNumber': 'Sipariş No',
  'delivery.customer': 'Müşteri',
  'delivery.items': 'Ürünler',
  'delivery.total': 'Toplam',
  'delivery.deliveryDate': 'Teslim Tarihi',
  'delivery.status': 'Durum',
  'delivery.actions': 'İşlemler',
  'delivery.markReady': 'Hazır Olarak İşaretle',
  'delivery.markDelivered': 'Teslim Edildi İşaretle',
  'delivery.printReceipt': 'Fiş Yazdır',
  
  // Delivery List Page
  'deliveryList.title': 'Teslim Listesi',
  'deliveryList.search': 'Fiş no, müşteri adı veya telefon...',
  'deliveryList.all': 'Tümü',
  'deliveryList.pending': 'İşlemde',
  'deliveryList.ready': 'Hazır',
  'deliveryList.date': 'Tarih',
  'deliveryList.pieces': 'Parça',
  'deliveryList.amount': 'Tutar',
  'deliveryList.readyButton': 'Hazır',
  'deliveryList.receiptButton': 'Fiş',
  'deliveryList.noOrders': 'Sipariş bulunamadı',
  'deliveryList.statusUpdated': 'Sipariş hazır olarak işaretlendi',
  'deliveryList.statusUpdateError': 'Durum güncellenemedi',
  'deliveryList.loadError': 'Siparişler yüklenemedi',
  'deliveryList.whatsappSending': '📱 WhatsApp mesajı gönderiliyor...',
'deliveryList.smsSent': '📨 SMS mesajı gönderildi',
  'deliveryList.items': 'Ürünler',
  'deliveryList.whatsappSent': 'WhatsApp mesajı gönderildi!',
  'deliveryList.whatsappError': 'WhatsApp mesajı gönderilemedi',
  'deliveryList.messageError': 'Müşteri mesajı gönderilemedi',
  'deliveryList.orderDelivered': 'Sipariş teslim edildi olarak işaretlendi',
  'deliveryList.orderCancelled': 'Sipariş iptal edildi',
  'deliveryList.deliveryError': 'Teslim edildi işaretlenirken hata',
  'deliveryList.cancelTitle': 'Fiş İptal',
  'deliveryList.cancelConfirm': 'Bu siparişi iptal etmek istediğinizden emin misiniz? İptal nedeni zorunludur.',
  'deliveryList.cancelReasonPlaceholder': 'İptal nedeni (zorunlu)...',
  'deliveryList.cancelButton': 'İptal Et',
  'deliveryList.cancelError': 'İptal hatası',
  'deliveryList.branchUpdated': 'Teslim şubesi güncellendi',
  'deliveryList.updateError': 'Güncellenemedi',
  'deliveryList.noPhone': 'Müşteri telefonu bulunamadı',
  'deliveryList.whatsappFailed': 'WhatsApp gönderilemedi',
  'deliveryList.whatsappTimeout': 'WhatsApp isteği zaman aşımına uğradı',
  'deliveryList.waRemind': 'WA Hatırlat',
  'deliveryList.homeDelivery': 'Adrese',
  'deliveryList.selectBranch': 'Şube seç',
  'deliveryList.noBranch': 'Şube seçilmedi',
  'deliveryList.pickup': 'alım',
  'deliveryList.noBranchAssigned': 'Şube atanmadı',
  'deliveryList.changeBranch': 'Teslim şubesini değiştir',

  // Delivery Page (Teslimat Ekranı)
  'deliveryPage.title': 'Teslimat',
  'deliveryPage.search': 'Fiş no, ad, telefon veya adres ile ara...',
  'deliveryPage.pieces': 'Parça',
  'deliveryPage.amount': 'Tutar',
  'deliveryPage.payment': 'Ödeme',
  'deliveryPage.deliverButton': 'Teslim Et',
  'deliveryPage.noOrdersFound': 'Teslime hazır sipariş bulunamadı',
  'deliveryPage.noReadyOrders': 'Teslime hazır sipariş bulunmamaktadır',
  'deliveryPage.minSearchLength': 'Aramak için en az 3 karakter girin',
  'deliveryPage.paymentDialogTitle': 'Teslimde Ödeme',
  'deliveryPage.ordersLoadError': 'Siparişler yüklenemedi',
  'deliveryPage.searchError': 'Arama yapılamadı',
  'deliveryPage.deliverySuccess': 'Sipariş teslim edildi',
  'deliveryPage.deliveryError': 'Teslim işlemi başarısız',
  'deliveryPage.whatsappSending': '📱 WhatsApp ile fiş gönderiliyor...',
  'deliveryPage.statusNotReady': 'Sipariş bulundu ancak teslime hazır değil',
  'deliveryPage.statusPending': 'İşlemde - Önce \\"Teslim Listesi\\" sayfasından hazır olarak işaretleyin',
  'deliveryPage.statusDelivered': 'Teslim Edilmiş',
  'deliveryPage.statusCancelled': 'İptal Edilmiş',
  'deliveryPage.receiptDelivered': '✅ *TESLİM EDİLDİ*',
  'deliveryPage.showItems': 'Ürünleri Göster',
  'deliveryPage.itemsList': 'Sipariş Detayı',
  'deliveryPage.quantity': 'Adet',
  'deliveryPage.unknownProduct': 'Ürün Bilinmiyor',
  'deliveryPage.searchBy': 'Arama Türü:',
  'deliveryPage.searchAll': 'Tümü',
  'deliveryPage.searchReceipt': 'Fiş No',
  'deliveryPage.searchName': 'Müşteri Adı',
  'deliveryPage.searchPhoneBtn': 'Telefon',
  'deliveryPage.searchPhone': 'Telefon numarası ile ara...',
  'deliveryPage.searchReceiptPlaceholder': 'Fiş no ile ara...',
  'deliveryPage.searchNamePlaceholder': 'Fiş no veya müşteri adı yazınız...',
  'deliveryPage.searchPlaceholder': 'Ara...',
  'deliveryPage.searchEmptyTitle': 'Fiş no, müşteri adı veya telefon ile arayın',
  'deliveryPage.searchEmptySubtitle': 'Arama yapınca teslim edilecek siparişler listelenir',
  
  // Delivery Section
  'delivery.deliveredItems': 'Teslim Edildi',
  'delivery.deliveredProducts': 'TESLİM EDİLEN ÜRÜNLER',
  'delivery.error': 'Teslimat hatası',
  
  // Receipt Page
  'receipt.title': 'Fiş ve Etiket',
  'receipt.customerReceipt': 'Müşteri Fişi',
  'receipt.back': 'Geri',
  'receipt.print': 'Fiş Bas',
  'receipt.whatsappSend': 'WhatsApp Gönder',
  'receipt.receiptNumber': 'Fiş No',
  'receipt.date': 'Tarih',
  'receipt.time': 'Saat',
  'receipt.product': 'Ürün',
  'receipt.quantity': 'Adet',
  'receipt.price': 'Fiyat',
  'receipt.totalPieces': 'Toplam Parça',
  'receipt.subtotal': 'Ara Toplam',
  'receipt.tax': 'KDV',
  'receipt.total': 'TOPLAM',
  'receipt.payment': 'Ödeme',
  'receipt.plannedDelivery': 'Planlanan Teslim',
  'receipt.notFound': 'Fiş bulunamadı',
  'receipt.newOrder': 'Yeni Sipariş',
  'receipt.search': 'Fiş Arama ve Yeniden Basım',
  'receipt.searchTitle': 'Fiş Ara',
  'receipt.searchPlaceholder': 'Fiş No, Müşteri Adı veya Telefon ile ara...',
  'receipt.searchReceiptPlaceholder': 'Fiş numarasını girin...',
  'receipt.searchEmpty': 'Aramak için fiş no veya müşteri adı girin',
  'receipt.noResults': 'Sonuç bulunamadı',
  'receipt.resultsCount': '{count} sonuç bulundu',
  'receipt.printButton': 'Fiş Bas',
  'receipt.products': 'ürün',
  'receipt.loadError': 'Veriler yüklenemedi',
  'receipt.whatsappOpening': 'WhatsApp açılıyor...',
  'receipt.labelPrinting': 'Etiket {current}/{total} basılıyor...',
  'receipt.andLabel': 've Etiket',
  'receipt.label': 'Etiket',
  'receipt.connected': 'Bağlı',
  'receipt.connect': 'Bağlan',
  'receipt.labelPrinted': 'Etiket basıldı!',
  'receipt.stain': 'Leke',
  'receipt.damage': 'Hasar',
  'receipt.taxPercent': 'KDV (%20)',
  'receipt.discount': 'İskonto',
  'receipt.discountedTotal': 'İndirimli Toplam',
  'receipt.generalTotal': 'Genel Toplam',
  'receipt.thankYou': 'Teşekkür ederiz',
  'receipt.footerNote': 'İyi günler dileriz',
  'receipt.area': 'Alan',
  'receipt.piece': 'adet',
  'receipt.homeDelivery': 'Adrese Teslim',
  'receipt.addressLabel': 'Adres',
  'receipt.thermalPrinter': 'Termal Yazıcı',
  'receipt.preview': 'Fiş Önizleme',
  'receipt.markAsReady': 'Siparişi Hazır Olarak İşaretle',
  'receipt.markAsDelivered': 'Siparişi Teslim Et',
  'receipt.backButton': 'Geri Dön',
  'receipt.status': 'Durum',
  'receipt.whatsappFeature': 'WhatsApp özelliği Professional ve Enterprise planlarda mevcuttur',
  'receipt.onlyProEnterprise': 'Yalnızca Pro/Enterprise',
  'receipt.copySend': 'WhatsApp Mesaj Gönder',
  'receipt.whatsappPreview': 'WhatsApp Mesajını Önizle',
  'receipt.whatsappPreviewTitle': 'WhatsApp Mesaj Önizlemesi',
  'receipt.whatsappPreviewDesc': 'Bu mesaj WhatsApp\'ta gönderilecek',
  'receipt.copyTip': 'İpucu: Metni seçip Ctrl+C ile de kopyalayabilirsiniz',
  'receipt.selectAll': 'Tümünü Seç',
  'receipt.copyButton': 'Kopyala',
  'receipt.openWhatsApp': 'WhatsApp\'ta Aç',
  'receipt.serviceSummary': 'HİZMET ÖZETİ',
  
  // Service Names (for receipt)
  'service.dryCleaningFull': 'Kuru Temizleme',
  
  // Payment Methods
  'payment.method': 'Ödeme Yöntemi',
  'payment.cash': 'Nakit',
  'payment.adjustment': 'Bakiye düzeltme',
  'payment.card': 'K.Kartı',
  'payment.creditCard': 'K.Kartı',
  'payment.mealCard': 'Yemek',
  'payment.account': 'Cari',
  'payment.onDelivery': 'Teslimde',
  'payment.bankTransfer': 'Havale/EFT',
  'payment.selectMethod': 'Ödeme yöntemini seçiniz',
  'payment.amount': 'Ödeme Tutarı',
  'payment.amountToPay': 'Ödenecek Tutar',
  'payment.paid': 'Ödenen',
  'payment.remaining': 'Kalan',
  'payment.complete': 'Ödemeyi Tamamla',
  'payment.confirm': 'Ödemeyi Onayla',
  'payment.posPayment': 'Kredi Kartı ile Ödeme (POS Cihazı)',
  'payment.posInstructions': 'Lütfen müşteriden POS cihazı ile ödeme alın.',
  'payment.posConfirm': 'POS cihazından ödeme onayını aldıktan sonra "Onayla" butonuna basın.',
  'payment.success': 'Ödeme başarılı',
  'payment.failed': 'Ödeme başarısız',
  'payment.splitPayment': 'Parçalı Ödeme',
  'payment.addPayment': 'Ödeme Ekle',
  'payment.status': 'Ödeme Durumu',
  'payment.pending': 'Bekliyor',
  'payment.completed': 'Tamamlandı',
  'payment.partial': 'Kısmi Ödeme',
  'payment.madePayments': 'Yapılan Ödemeler',
  'payment.enterAmount': 'Ödeme Miktarı Girin',
  
  // WhatsApp Messages
  'whatsapp.orderReady': 'Siparişiniz hazır! 🎉',
  'whatsapp.receiptMessage': 'Sayın {customerName}, {orderNumber} nolu siparişiniz hazır ve teslime hazır bekliyor.',
  'whatsapp.deliveryReminder': '{customerName}, {orderNumber} nolu siparişinizi {daysAgo} gündür almadınız. Lütfen en kısa sürede teslim alınız.',
  'whatsapp.thankYou': 'Teşekkürler!',
  
  // Customers Page
  'customers.title': 'Müşteriler',
  'customers.addNew': 'Yeni Müşteri',
  'customers.search': 'Müşteri Ara...',
  'customers.name': 'Ad Soyad',
  'customers.phone': 'Telefon',
  'customers.email': 'E-posta',
  'customers.address': 'Adres',
  'customers.totalOrders': 'Sipariş Sayısı',
  'customers.totalSpent': 'Toplam Harcama',
  'customers.balance': 'Bakiye',
  'customers.actions': 'İşlemler',
  'customers.edit': 'Düzenle',
  'customers.delete': 'Sil',
  'customers.noCustomers': 'Müşteri bulunamadı',
  'customers.noResults': 'Sonuç bulunamadı',
  'customers.showingFirst50': 'İlk 50 sonuç gösteriliyor',
  'customers.totalResults': 'toplam',
  'customers.tableCustomer': 'Müşteri',
  'customers.tableContact': 'İletişim',
  'customers.tableAddress': 'Adres',
  'customers.tableNotifications': 'Bildirimler',
  'customers.tableBalance': 'Bakiye',
  'customers.tableActions': 'İşlemler',
  'customers.totalCount': 'Toplam {count} müşteri',
  'customers.notes': 'Not',
  'customers.whatsappEnabled': 'WhatsApp',
  'customers.smsEnabled': 'SMS',
  'customers.searchPlaceholder': 'İsim, telefon, email veya adres ara... (örnek: ali+5551234567)',
  'customers.updated': 'Müşteri güncellendi',
  'customers.updateError': 'Müşteri güncellenemedi',
  'customers.added': 'Müşteri eklendi',
  'customers.addError': 'Müşteri eklenemedi',
  'customers.deleted': 'Müşteri silindi',
  'customers.deleteError': 'Müşteri silinemedi',
  'customers.deleteConfirm': '"{name}" müşterisini silmek istediğinize emin misiniz?',
  'customers.loadError': 'Müşteriler yüklenemedi',
  'customers.import': 'Müşteri İçe Aktar',
  'customers.importTitle': 'Müşteri İçe Aktar',
  'customers.telefon': 'Telefon',
  'customers.telefon2': 'Telefon 2',
  'customers.adres': 'Adres',
  'customers.notFound': 'Müşteri bulunamadı',
  'customers.legacyHidden': 'Eski format müşteriler gizlendi',
  'customers.cannotDeleteWithOrders': 'Bu müşteri silinemez! Müşteriye ait siparişler bulunmaktadır.',
  'customers.phoneMissing': 'Müşterinin telefon numarası kayıtlı değil',
  
  // Dashboard
  'settings.title': 'Ayarlar',
  'settings.general': 'Genel Ayarlar',
  'settings.companyInfo': 'Firma Bilgileri',
  'settings.companyName': 'Firma Adı',
  'settings.companyNamePlaceholder': 'Firma adını girin',
  'settings.language': 'Dil',
  'settings.languageRegion': 'Dil ve Bölge',
  'settings.address': 'Adres',
  'settings.addressPlaceholder': 'Firma adresini girin',
  'settings.phone': 'Telefon',
  'settings.logo': 'Logo',
  'settings.demoProducts': 'Demo Ürünleri',
  'settings.demoProductsDescription': 'Tanımlı fiyatları ile birlikte demo ürünleri ekler',
  'settings.addDemoProducts': 'Demo Ürünlerini Ekle',
  'settings.adding': 'Ekleniyor...',
  'settings.delete': 'Sil',
  'settings.currency': 'Para Birimi',
  'settings.currencyPosition': 'Para Birimi Konumu',
  'settings.currencyPositionLeft': 'Sol ($100.00)',
  'settings.currencyPositionRight': 'Sağ (100.00₺)',
  'settings.currencyPositionPreview': 'Simge {position}: {example}',
  'settings.currencyPositionPreviewLeft': 'Simge solda',
  'settings.currencyPositionPreviewRight': 'Simge sağda',
  'settings.numberFormat': 'Sayı Formatı',
  'settings.numberFormatDotComma': '1,234.56 (ABD)',
  'settings.numberFormatCommaDot': '1.234,56 (TR/EU)',
  'settings.numberFormatSpaceComma': '1 234,56 (FR/RU)',
  'settings.currencyFormat': 'Para Formatı',
  'settings.showDecimals': 'Kuruş Göster',
  'settings.showDecimalsDesc': 'Fiyatlarda ondalık kısmı (kuruş) göster',
  'settings.dateFormat': 'Tarih Formatı',
  'settings.timezone': 'Saat Dilimi',
  'settings.deliveryDays': 'Teslimat Süresi (Gün)',
  'settings.workOnSunday': 'Pazar Günleri Çalış',
  'settings.defaultServiceType': 'Varsayılan Servis Türü',
  'settings.defaultServiceTypeDesc': 'Ürün kayıt ekranı açıldığında otomatik seçili gelecek servis türü',
  'settings.defaultCategory': 'Varsayılan Kategori',
  'settings.defaultCategoryDesc': 'Ürün kayıt ekranı açıldığında otomatik seçili gelecek kategori',
  'settings.companyLogo': 'Firma Logosu',
  'settings.logoDescription': 'Logo fişlerde ve program sol üstünde görünecektir. Önerilen boyut: En az 300x120px, yüksek çözünürlüklü PNG veya JPG',
  'settings.uploadLogo': 'Logo Yükle',
  'settings.removeLogo': 'Logoyu Kaldır',
  'settings.noLogo': 'Logo yok',
  'settings.whatsappTemplates': 'WhatsApp Mesaj Şablonları',
  'settings.smsTemplates': 'SMS Mesaj Şablonları',
  'settings.orderCreated': 'Sipariş Oluşturuldu',
  'settings.orderReady': 'Sipariş Hazır',
  'settings.orderDelivered': 'Sipariş Teslim Edildi',
  'settings.receiptSettings': 'Fiş Ayarları',
  'settings.showTax': 'KDV Göster',
  'settings.taxRate': 'KDV Oranı (%)',
  'settings.footerText': 'Alt Bilgi Metni',
  'settings.footerTextPlaceholder': 'Fiş altında görünecek metin...',
  'settings.receiptFooterText': 'Fiş Alt Yazısı',
  'settings.receiptNote': 'Fiş Notu',
  'settings.receiptNotePlaceholder': 'Fiş notu...',
  'settings.socialMedia': 'Sosyal Medya & İletişim',
  'settings.instagram': 'Instagram',
  'settings.facebook': 'Facebook',
  'settings.website': 'Website',
  'settings.dangerZone': 'Tehlikeli Bölge',
  'settings.deleteDemoDataWarning': 'Kurulumda otomatik eklenen örnek müşteriler ile bu müşterilere ait fiş ve ödemeler silinir. Kendi eklediğiniz müşteriler ve fişler silinmez.',
  'settings.productsWillBeKept': 'Ürün tanımları korunacaktır.',
  'settings.deleteDemoDataTitle': 'Demo Verileri Silinecek',
  'settings.deleteDemoDataConfirm': 'Bu işlem geri alınamaz! Örnek müşteriler ve onların fiş/ödemeleri silinecek; kendi müşterileriniz ve fişleriniz korunacak.',
  'toast.noDemoData': 'Silinecek örnek müşteri bulunamadı.',
  'toast.demoCustomersKept': '{n} örnek müşteriye sizin kestiğiniz fiş olduğu için kartı korundu; sadece örnek fişleri silindi.',
  'settings.areYouSure': 'Emin misiniz?',
  'settings.deleting': 'Siliniyor...',
  'settings.loadSchema': 'Şema Yükle',
  'settings.loadSchemaTitle': 'Veritabanı Şeması Yükle',
  'settings.loadSchemaConfirm': 'Bu, veritabanı şemasını oluşturacaktır. Devam?',
  'settings.yesDelete': 'Evet, Sil',
  'settings.deleteDemoData': 'Demo Datasını Sil',
  'settings.deleteDemoDataDesc': 'Bu işlem tüm demo müşterilerini, siparişleri ve ödeme kayıtlarını kalıcı olarak silecektir.',
  'settings.deleteButton': 'Demo Datasını Sil',
  'settings.save': 'Kaydet',
  'settings.loading': 'Yükleniyor...',
  'settings.headerInfo': 'Üst Bilgi',
  'settings.headerInfoPlaceholder': 'örn: Kuru Temizleme & Ütü',
  'settings.phonePlaceholder': 'örn: 0212 123 45 67',
  'settings.footerTextHelp': 'Fiş altında görünecek kısa mesaj',
  'settings.receiptNoteHelp': 'Detaylı şartlar ve koşullar',
'settings.receiptPreview': 'Fiş Önizleme',
  
  // Settings - New translations
  'settings.popularLanguages': 'Popüler Diller',
  'settings.europeanLanguages': 'Avrupa Dilleri',
  'settings.asianLanguages': 'Asya Dilleri',
  'settings.middleEastAfricanLanguages': 'Ortadoğu & Afrika Dilleri',
  'settings.otherLanguages': 'Diğer Diller',
  'settings.majorCurrencies': 'Ana Para Birimleri',
  'settings.middleEastGulf': 'Orta Doğu & Körfez',
  'settings.formerSovietTurkic': 'Eski Sovyet & Türk',
  'settings.oceania': 'Okyanusya',
  'settings.turkey': 'Türkiye',
  'settings.middleEast': 'Orta Doğu',
  'settings.asia': 'Asya',
  'settings.labelPrinter': 'Etiket Yazıcı',
  'settings.printerSettings': 'Yazıcı Ayarları',
  'settings.webSerialSupported': 'Web Serial API Destekleniyor',
  'settings.browserNotSupported': 'Tarayıcı Desteklemiyor',
  'settings.connected': 'Bağlı',
  'settings.notConnected': 'Bağlı Değil',
  'settings.connect': 'Bağlan',
  'settings.disconnect': 'Bağlantıyı Kes',
  'settings.printerModel': 'Yazıcı Modeli',
  'settings.paperWidth': 'Kağıt Genişliği',
  'settings.autoConnect': 'Otomatik bağlan',
  'settings.feedForward': 'İleri Besle',
  'settings.reverse': 'Geri Çek',
  'settings.cut': 'Kes',
  'settings.openDrawer': 'Çekmece Aç',
  'settings.testPrint': 'Test Yazdır',
  'settings.testPrinted': 'Test yazdırıldı!',
  'settings.webSerialNotSupported': 'Web Serial API tarayiciniz tarafindan desteklenmiyor. Chrome tabanli tarayicilar (Chrome, Edge, Brave) kullanmanizi öneririz.',
  'settings.callerId': 'Arayan Kimliği (Caller ID)',
  'settings.lastCall': 'Son arama',
  'settings.howToConnect': '💡 Nasıl Bağlanır?',
  'settings.connectDeviceInfo': 'USB Caller ID cihazını bilgisayara bağlayın',
  'settings.clickConnectButton': '"Bağlan" butonuna tıklayın',
  'settings.selectDevice': 'Açılan listeden CID cihazını seçin (genellikle "USB Serial Device")',
  'settings.testPrintHeader': '=== TEST YAZICI ===',
  'settings.printerConnection': 'Yazici baglantisi',
  'settings.successful': 'basarili!',
  'settings.reverseTest': '--- Ters odeme testi ---',
  'settings.receiptVisibleOnReceipt': 'Fişte Görünür',
  'settings.company': 'Firma',
  'settings.email': 'E-posta',
  'settings.saved': 'Ayarlar kaydedildi!',
  'settings.saveError': 'Ayarlar kaydedilemedi',
  'settings.notifications': 'Bildirimler',
  'settings.integrations': 'Entegrasyonlar',
  'settings.printer': 'Yazıcı',
  'settings.printerConnected': 'Bağlı',
  'settings.printerNotConnected': 'Bağlı Değil',
  'settings.printerConnect': 'Bağlan',
  'settings.printerDisconnect': 'Bağlantıyı Kes',
  'settings.afrika': 'Afrika',
  'settings.genericEscPos': 'Genel ESC/POS',
  
  // Signup
  'signup.companyDetails': 'Şirket Bilgileri',
  'signup.subtitle': '15 günlük ücretsiz denemenizi başlatın',
  'signup.fields.companyCode': 'Şirket Kodu',
  'signup.placeholders.companyCode': 'örn: cleanpro',
  'signup.hints.companyCode': 'Bu kod giriş yaparken kullanılacaktır. Sadece harf ve rakam içerebilir.',
  'signup.fields.companyName': 'Şirket Adı',
  'signup.placeholders.companyName': 'örn: CleanPro Kuru Temizleme',
  'signup.fields.ownerName': 'Ad Soyad',
  'signup.placeholders.ownerName': 'örn: Ahmet Yılmaz',
  'signup.fields.email': 'E-posta Adresi',
  'signup.placeholders.email': 'örn: ahmet@cleanpro.com',
  'signup.fields.phone': 'Telefon Numarası',
  'signup.placeholders.phone': 'örn: +90 555 123 4567',
  'signup.fields.country': 'Ülke',
  'signup.hints.country': 'Ülkenize göre para birimi ve dil ayarları otomatik yapılacaktır.',
  'signup.freeTrial': '🎁 15 gün ücretsiz kullanım hediye!',
  'signup.businessType.question': 'Hangi işi yapıyorsunuz?',
  'signup.businessType.hint': 'Seçiminize göre varsayılan ekran otomatik ayarlanır',
  'signup.businessType.continue': 'Devam Et',
  'signup.bt.dryCleaning.desc': 'Giysi, perde, tekstil temizliği',
  'signup.bt.carpetWashing.desc': 'Halı, kilim, yolluk yıkama',
  'signup.bt.shoeShine.desc': 'Ayakkabı temizlik ve bakımı',
  'signup.bt.sofaWashing.desc': 'Koltuk, kanepe, berjer yıkama',
  'signup.bt.carWash.desc': 'Oto yıkama, cila, pasta ve detailing',
  'signup.bt.tailoring.desc': 'Terzi, tadilat ve dikim hizmetleri',
  'signup.bt.barber.desc': 'Kuaför, berber ve güzellik salonu',
  'signup.createAccount': 'Hesap Oluştur',
  'signup.haveAccount': 'Zaten hesabınız var mı? Giriş yapın',
  'signup.creating': 'Hesap oluşturuluyor...',
  'signup.success': 'Hesabınız başarıyla oluşturuldu!',
  'signup.errors.companyCodeRequired': 'Şirket kodu gereklidir',
  'signup.errors.companyCodeTooShort': 'Şirket kodu en az 3 karakter olmalıdır',
  'signup.errors.companyNameRequired': 'Şirket adı gereklidir',
  'signup.errors.ownerNameRequired': 'Ad Soyad gereklidir',
  'signup.errors.emailRequired': 'E-posta adresi gereklidir',
  'signup.errors.emailInvalid': 'Geçerli bir e-posta adresi giriniz',
  'signup.errors.signupFailed': 'Hesap oluşturma başarısız oldu',

  // Common
  'common.autoDetected': 'Otomatik Tespit Edildi',

  // Footer
  'footer.euServers': '',
  'footer.gdpr': '',

  // Toasts
  'toast.settingsSaved': 'Ayarlar kaydedildi',
  'toast.settingsError': 'Ayarlar kaydedilemedi',
  'toast.settingsLoadError': 'Ayarlar yüklenemedi',
  'toast.logoUploaded': 'Logo yüklendi. Kaydetmeyi unutmayın!',
  'toast.logoRemoved': 'Logo kaldırıldı. Kaydetmeyi unutmayın!',
  'toast.logoSizeError': "Logo dosyası 500KB'dan küçük olmalıdır",
  'toast.logoTypeError': 'Sadece resim dosyaları yüklenebilir',
  'toast.demoDataDeleted': 'Demo datası silindi',
  'toast.demoDataDeleteError': 'Demo datası silinemedi',
  'toast.orderCreated': 'Sipariş oluşturuldu',
  'toast.orderError': 'Sipariş oluşturulamadı',
  'toast.customerAdded': 'Müşteri eklendi',
  'toast.customerError': 'Müşteri eklenemedi',
  'toast.productAdded': 'Ürün eklendi',
  'toast.productError': 'Ürün eklenemedi',
  'toast.qrGenerated': 'QR kod oluşturuldu. Lütfen WhatsApp Business uygulamanızla tarayın.',
  'toast.qrError': 'QR kod oluşturulamadı',
  'toast.whatsappConnected': 'WhatsApp Business başarıyla bağlandı!',
  'toast.whatsappDisconnected': 'WhatsApp Business bağlantısı kesildi',
  'toast.connectionError': 'Bağlantı kaydedilemedi',
  'toast.disconnectError': 'Bağlantı kesilemedi',
  'toast.connectionStatusError': 'Bağlantı durumu yüklenemedi',
  'toast.orderSaved': 'Sıralama kaydedildi',
  'toast.orderSaveError': 'Sıralama kaydedilemedi',
  'toast.statsError': 'İstatistikler yüklenemedi',
  'toast.userAdded': 'Kullanıcı eklendi',
  'toast.userAddError': 'Kullanıcı eklenemedi',
  'toast.userUpdated': 'Kullanıcı güncellendi',
  'toast.userUpdateError': 'Kullanıcı güncellenemedi',
  'toast.usersLoadError': 'Kullanıcılar yüklenemedi',
  'toast.pinChanged': 'PIN kodu değiştirildi',
  'toast.pinChangeError': 'PIN kodu değiştirilemedi',
  'toast.userDeleted': 'Kullanıcı başarıyla silindi/pasifleştirildi',
   'toast.userDeleteError': 'Kullanıcı silinemedi',
   'toast.orderDetailsLoadError': 'Sipariş detayları yüklenemedi',
   'toast.orderLoadError': 'Sipariş yüklenemedi',
   'toast.deliveryDatePastError': 'Teslim tarihi bugünden önce olamaz',
   'toast.fillAllCardInfo': 'Lütfen tüm kart bilgilerini doldurun',
   'toast.invalidCardNumber': 'Geçersiz kart numarası',
   'toast.invalidMonth': 'Geçersiz ay (1-12 arası olmalı)',
   'toast.invalidYear': 'Geçersiz yıl',
   'toast.invalidCvc': 'Geçersiz CVC',
   'toast.addressRequiredForDelivery': 'Adrese teslim/alma için müşteri adresi gerekli. Lütfen adres bilgisini doldurun.',
   'toast.cardPaymentSuccessMsg': 'Kart ödemesi başarılı!',
   'toast.cardPaymentFailed': 'Ödeme başarısız oldu. Lütfen tekrar deneyin.',
   'toast.paymentStatusCheckError': 'Ödeme durumu kontrol edilemedi. Lütfen cari hesabınızı kontrol edin.',
   'toast.paymentStatusCheckErrorShort': 'Ödeme durumu kontrol edilemedi.',
   'toast.selectCustomer': 'Lütfen müşteri seçiniz',
   'toast.addProduct': 'Lütfen ürün ekleyiniz',
   'toast.productAddedSimple': 'Ürün eklendi',
   'toast.editCancelled': 'Düzenleme iptal edildi',
   'toast.searchError': 'Arama hatası',
   'toast.customerDebt': 'Müşteri borcu: {amount}',
   'toast.customerOpenOrders': 'Müşterinin {count} adet açık siparişi var',
   'toast.productAddedToCart': 'Ürün sepete eklendi',
   
   // Subscription Banner
  'subscription.warning': 'Abonelik Uyarısı',
  'subscription.expiringDays': 'Aboneliğinizin süresi {days} gün sonra dolacak. Hizmetinizin kesintisiz devam etmesi için lütfen yenileyin.',
  'subscription.renew': 'Aboneliği Yenile',
  
  // Common
  'common.yes': 'Evet',
  'common.no': 'Hayır',
  'common.cancel': 'İptal',
  'common.confirm': 'Onayla',
  'common.delete': 'Sil',
  'common.edit': 'Düzenle',
  'common.unit': 'Birim',
  'common.ok': 'Tamam',
  'common.save': 'Kaydet',
  'common.search': 'Ara',
  'common.loading': 'Yükleniyor...',
  'common.searchResults': '(Arama sonucu)',
  'common.noData': 'Veri yok',
  'common.actions': 'İşlemler',
  'common.status': 'Durum',
  'common.date': 'Tarih',
  'common.time': 'Saat',
  'common.total': 'Toplam',
  'common.perPage': 'Sayfa Başına',
  'common.page': 'Sayfa',
  'common.orders': 'sipariş',
  'common.previous': 'Önceki',
  'common.next': 'Sonraki',
  'common.filter': 'Filtrele',
  'common.export': 'Dışa Aktar',
  'common.exportExcel': 'Excel İndir',
  'common.exportToExcel': 'Excel\'e Aktar',
'common.print': 'Yazdır',
  'common.printDate': 'Yazdırma Tarihi',
  'common.pieces': 'parça',
  'currentPin': 'Mevcut PIN',
  'newPin': 'Yeni PIN',
  'confirmPin': 'PIN Onayla',
  'pinDigits': '6 haneli',
  'changePin': 'PIN Değiştir',
  'changingPin': 'Değiştiriliyor...',

  // Common (eksik)
  'common.back': 'Geri',
  'common.cancel': 'İptal',
  'common.clear': 'Temizle',
  'common.create': 'Oluştur',
  'common.creating': 'Oluşturuluyor...',
  'common.items': 'Ürünler',
  'common.later': 'Daha Sonra',
  'common.loadError': 'Yüklenemedi',
  'common.none': 'Yok',
  'common.paid': 'Ödendi',
  'common.searchError': 'Arama hatası',
  'common.submit': 'Gönder',
  'common.year': 'Yıl',
  'common.allYears': 'Tüm Yıllar',
  'common.cancelled': 'İptal Edildi',

  // Account Statement (eksik)
  'accountStatement.customerReceipts': 'Müşteri Fişleri',
  'accountStatement.noReceipts': 'Fiş bulunamadı',
  'accountStatement.printStatement': 'Ekstreyi Yazdır',

  // Customer Statement
  'customerStatement.receiptDelivered': 'Teslim Edildi',
  'customerStatement.receiptOpen': 'Açık',

  // Customers (eksik)
  'customers.add': 'Müşteri Ekle',

  // Delivery (eksik)
  'delivery.complete': 'Teslim Et',
  'delivery.noOrders': 'Sipariş bulunamadı',
  'delivery.success': 'Teslim başarılı',

  // Driver
  'driver.delivery': 'Teslimat',
  'driver.searchHint': 'Arama yapmak için en az 2 karakter girin',
  'driver.searchPlaceholder': 'Fiş no, ad veya telefon...',

  // Invoices
  'invoices.downloading': 'İndiriliyor...',

  // Order (eksik)
  'order.amount': 'Tutar',
  'order.processing': 'İşleniyor...',

  // Payment (eksik)
  'payment.bank': 'Havale/EFT',
  'payment.collect': 'Tahsil Et',
  'payment.credit': 'Veresiye',
  'payment.free': 'Bedelsiz',
  'payment.paymentCare': 'Cari Ödeme',
  'payment.paymentsSaved': 'Ödemeler kaydedildi',
  'payment.saveError': 'Ödemeler kaydedilemedi',
  'payment.saved': 'Ödeme kaydedildi',
  'payment.split': 'Parçalı Ödeme',

  // Product
  'product.damage': 'Hasar',
  'product.stain': 'Leke',

  // Receipt (eksik)
  'receipt.cancelledReason': 'İptal Nedeni',
  'receipt.goToWhatsAppPage': 'WhatsApp bağlantı sayfasına gitmek ister misiniz?',
  'receipt.messageFailed': 'Mesaj gönderilemedi',
  'receipt.messageSendFailed': 'Mesaj gönderilemedi',
  'receipt.orderNumber': 'Sipariş No',
  'receipt.phoneNotFound': 'Telefon numarası bulunamadı',
  'receipt.printError': 'Yazdırma hatası',
  'receipt.printerConnectError': 'Yazıcıya bağlanılamadı',
  'receipt.sessionNotFound': 'Oturum bulunamadı. Lütfen tekrar giriş yapın.',
  'receipt.unknownError': 'Bilinmeyen hata',

  // Settings (eksik)
  'settings.africa': 'Afrika',
  'settings.americas': 'Amerika',
  'settings.asiaPacific': 'Asya Pasifik',
  'settings.europe': 'Avrupa',

  // Signup
  'signup.referral.bonus': 'Referans bonusu',
  'signup.referral.title': 'Davet Kodu',

  // Tickets
  'tickets.admin': 'Yönetici',
  'tickets.closed': 'Kapalı',
  'tickets.closedMessage': 'Bu destek talebi kapatılmıştır.',
  'tickets.conversation': 'Konuşma',
  'tickets.createError': 'Destek talebi oluşturulamadı',
  'tickets.created': 'Destek talebi oluşturuldu',
  'tickets.description': 'Açıklama',
  'tickets.descriptionPlaceholder': 'Sorununuzu detaylı açıklayın...',
  'tickets.fillAllFields': 'Lütfen tüm alanları doldurun',
  'tickets.loadError': 'Destek talepleri yüklenemedi',
  'tickets.messages': 'Mesajlar',
  'tickets.newTicket': 'Yeni Talep',
  'tickets.noTickets': 'Destek talebi bulunamadı',
  'tickets.noTicketsDesc': 'Henüz destek talebiniz bulunmamaktadır',
  'tickets.rateDescription': 'Destek deneyiminizi değerlendirin',
  'tickets.rateExperience': 'Deneyiminizi Değerlendirin',
  'tickets.rateSupport': 'Destek Puanı',
  'tickets.rating.bad': 'Kötü',
  'tickets.rating.excellent': 'Mükemmel',
  'tickets.rating.good': 'İyi',
  'tickets.rating.okay': 'Orta',
  'tickets.rating.veryBad': 'Çok Kötü',
  'tickets.ratingError': 'Puanlama kaydedilemedi',
  'tickets.ratingSubmitted': 'Puanınız kaydedildi, teşekkürler!',
  'tickets.selectRating': 'Puan Seçin',
  'tickets.sendError': 'Mesaj gönderilemedi',
  'tickets.status.closed': 'Kapalı',
  'tickets.status.investigating': 'İnceleniyor',
  'tickets.status.open': 'Açık',
  'tickets.status.waitingCustomer': 'Müşteri Bekleniyor',
  'tickets.subject': 'Konu',
  'tickets.subjectPlaceholder': 'Destek konusu...',
  'tickets.title': 'Destek Talepleri',
  'tickets.translationError': 'Çeviri hatası',
  'tickets.typeMessage': 'Mesajınızı yazın...',
  'tickets.yourName': 'Adınız',
  'tickets.yourNamePlaceholder': 'Adınızı girin...',
  'tickets.yourRating': 'Puanınız',

  // Toast (eksik)
  'toast.amountExceedsRemaining': 'Tutar kalan miktarı aşıyor',
  'toast.cardPaymentError': 'Kart ödeme hatası',
  'toast.cardPaymentSuccess': 'Kart ödemesi başarılı',
  'toast.carpetAddedToCart': 'Halı sepete eklendi',
  'toast.carpetsAddedToCart': 'Halılar sepete eklendi',
  'toast.customerExistingSelected': 'Mevcut müşteri seçildi',
  'toast.customerPhoneNotFound': 'Müşteri telefonu bulunamadı',
  'toast.customerSaveError': 'Müşteri kaydedilemedi',
  'toast.customerSaved': 'Müşteri kaydedildi',
  'toast.customerUpdateError': 'Müşteri güncellenemedi',
  'toast.customerUpdated': 'Müşteri güncellendi',
  'toast.enterValidAmount': 'Geçerli bir tutar girin',
  'toast.enterValidArea': 'Geçerli bir alan girin',
  'toast.enterValidValue': 'Geçerli bir değer girin',
  'toast.logoTooLarge': 'Logo dosyası çok büyük',
  'toast.logoUploadError': 'Logo yüklenemedi',
  'toast.noEditPermission': 'Düzenleme yetkiniz yok',
  'toast.orderNotFound': 'Sipariş bulunamadı',
  'toast.orderSetToReady': 'Sipariş hazır olarak işaretlendi',
  'toast.orderUpdateError': 'Sipariş güncellenemedi',
  'toast.paymentFailedTryAgain': 'Ödeme başarısız, lütfen tekrar deneyin',
  'toast.priceUpdated': 'Fiyat güncellendi',
  'toast.productDetailsUpdated': 'Ürün detayları güncellendi',
  'toast.productsLoadError': 'Ürünler yüklenemedi',
  'toast.selectAtLeastOneOperation': 'En az bir işlem seçin',
  'toast.selectAtLeastOneService': 'En az bir hizmet seçin',
  'toast.selectPaymentMethodFirst': 'Önce ödeme yöntemi seçin',
  'toast.statusUpdateError': 'Durum güncellenemedi',
  'toast.tailorAddedToCart': 'Terzi işlemi sepete eklendi',
  'toast.uploadingLogo': 'Logo yükleniyor...',
  'toast.whatsappFailed': 'WhatsApp gönderilemedi',
  'toast.whatsappSent': 'WhatsApp gönderildi',

  // ZReport notes
  'zReport.cashBoxStartNote': 'Kasa başlangıç tutarı',
  'zReport.todayCashNote': 'Bugün alınan nakit',
  'zReport.branchCollectionsNote': 'Kendi + diğer şube tahsilatı',
  'zReport.dailyExpensesNote': 'Bugünkü giderler',

  // CustomerCard
  'customerCard.balanceZero': 'Bakiye zaten sıfır.',
  'customerCard.debtLabel': 'borç silinecek',
  'customerCard.creditLabel': 'alacak silinecek',
  'customerCard.resetConfirm': 'Bakiye sıfırlanacak ({label}). Onaylıyor musunuz?',
  'customerCard.resetSuccess': 'Bakiye sıfırlandı',
  'customerCard.resetError': 'Bakiye sıfırlanamadı',
  'customerCard.printTitle': 'Müşteri Kartı',
  'customerCard.heading': 'MÜŞTERİ KARTI',
  'customerCard.tel1': 'TEL 1',
  'customerCard.tel2': 'TEL 2',
  'customerCard.address': 'ADRES',
  'customerCard.printButton': 'Müşteri Kartı Bas',
  'customerCard.resetting': 'Sıfırlanıyor...',
  'customerCard.resetBalance': 'Bakiyeyi Sıfırla',

  // Tailoring (missing)
  'tailoring.loadError': 'Fiyatlar yüklenemedi',
  'tailoring.nameRequired': 'İşlem adı giriniz',
  'tailoring.invalidPrice': 'Geçerli bir fiyat giriniz',
  'tailoring.addSuccess': 'Yeni terzi işlemi eklendi!',
  'tailoring.saveError': 'Kaydetme hatası',
  'tailoring.deleteConfirm': 'Bu terzi işlemini silmek istediğinizden emin misiniz?',
  'tailoring.deleteSuccess': 'Terzi işlemi silindi',
  'tailoring.deleteError': 'Silme hatası',
  'tailoring.saveSuccess': 'Terzi fiyatları kaydedildi!',
  'tailoring.addNewTitle': 'Yeni Terzi İşlemi Ekle',
  'tailoring.operationNameLabel': 'İşlem Adı',
  'tailoring.priceLabel': 'Fiyat',
  'tailoring.iconLabel': 'İkon (Emoji)',
  'tailoring.operationNamePlaceholder': 'Ör: Yaka Dikimi',
  'tailoring.savePricesHint': 'Fiyatları kaydetmek için Kaydet düğmesine tıklayın',
  'tailoring.addCustomHint': 'Özel işlem eklemek için + butonunu kullanın',

  // ReportsList (missing)
  'reportsList.title': 'Fiş Listesi Raporu',
  'reportsList.startDate': 'Başlangıç Tarihi',
  'reportsList.endDate': 'Bitiş Tarihi',
  'reportsList.search': 'Ara',
  'reportsList.loading': 'Yükleniyor...',
  'reportsList.description': 'Bu tarih aralığında kayıt edilen veya teslim edilen fişlerin tümü listelenir',
  'reportsList.empty': 'Bu tarih aralığında fiş bulunamadı',
  'reportsList.changeDateRange': 'Farklı bir tarih aralığı seçin',
  'reportsList.categoryBreakdown': 'Kategoriye Göre Dağılım',
  'reportsList.unknown': 'Bilinmeyen',
  'reportsList.cancelReason': 'İptal Nedeni:',
  'reportsList.excelDownloaded': 'Excel dosyası indirildi',
  'reportsList.excelError': 'Excel dosyası oluşturulamadı',
  'reportsList.totalReceipt': 'Toplam Fiş',
  'reportsList.activeReceipt': 'Aktif Fiş',
  'reportsList.loadError': 'Fiş listesi yüklenemedi',
  'reportsList.dateError': 'Başlangıç tarihi bitiş tarihinden sonra olamaz',

  // Receipt label dialog
  'receipt.labelConfirmTitle': 'Etiket Basılsın mı?',
  'receipt.labelConfirmDesc': 'Fiş kesildi. Etiket yazıcısına etiket gönderilsin mi?',
  'receipt.labelYes': 'Evet, Bas',
  'receipt.labelNo': 'Hayır',

  // Subscription page – missing UI strings
  'subscription.subtitle': 'Planınızı yönetin ve faturalandırma ayarlarınızı yapın',
  'subscription.renewsInDays': 'Mevcut aboneliğiniz {days} gün içinde yenilenecek',
  'subscription.expiryLabel': 'Son kullanım:',
  'subscription.autoRenewActive': '✅ Otomatik yenileme aktif - Sonraki ödeme:',
  'subscription.manageBilling': 'Fatura Yönetimi',
  'subscription.cancelSubBtn': '❌ Aboneliği İptal Et',
  'subscription.subCancelledBadge': '⚠️ Abonelik iptal edildi',
  'subscription.paymentRequiredBadge': '💳 Yenileme için ödeme gereklidir',
  'subscription.comparePlans': 'Planları Karşılaştırın',
  'subscription.yearlyFreeBtn': '🎉 Yıllık (2 Ay Bedava!)',
  'subscription.vatNote': '+ KDV (%20)',
  'subscription.autoRenewBadge': '🔄 Otomatik yenilenebilir abonelik',
  'subscription.emailNotifBadge': '💳 Yenileme öncesi e-posta bildirimi',
  'subscription.extendBtn': 'Aboneliği Uzat',
  'subscription.selectBtn': 'Seç',
  'subscription.upgradeBtn': 'Yükselt',
  'subscription.usageTitle': 'Bu Ayki Kullanım ve Limitler',
  'subscription.receiptsLabel': 'Fişler',
  'subscription.customersLabel': 'Müşteriler',
  'subscription.usersLabel': 'Kullanıcılar',
  'subscription.supportTimeLabel': 'Destek Ticket Süresi',
  'subscription.referralTitle': 'Arkadaşlarına Tavsiye Et',
  'subscription.referralDesc': 'Davet ettiğin arkadaşın kayıt olup üye olduğunda 1 ay ekstra süre kazanırsın! Yalnızca davet göndermek yetmez.',
  'subscription.referralShare': 'Davet Linkini Paylaş',
  'subscription.faqTitle': 'Sık Sorulan Sorular',
  'subscription.faq1q': 'Plan değiştirirken ne olur?',
  'subscription.faq1a': 'Plan değiştirdiğinizde hemen yeni özelliklere erişim kazanırsınız. Aldığınız kiralama süresi (aylık veya yıllık), mevcut kiralama sürenizin üzerine eklenir.',
  'subscription.faq2q': 'İptal edersem ne olur?',
  'subscription.faq2a': 'Aboneliğinizi iptal ederseniz, mevcut dönem sonuna kadar hizmet almaya devam edersiniz. Verileriniz 15 gün boyunca saklanır.',
  'subscription.faq3q': 'Hangi ödeme yöntemlerini kabul ediyorsunuz?',
  'subscription.faq3a': 'Sadece kredi kartı ve banka kartı ile ödeme kabul edilmektedir. Havale/EFT ile ödeme yapılamaz.',
  'subscription.faq4q': '15 günlük deneme nasıl çalışır?',
  'subscription.faq4a': 'Hesap açıldıktan itibaren 15 gün boyunca tüm özellikleri ücretsiz kullanabilirsiniz. Deneme süresi bittiğinde abonelik satın almanız gerekir.',
  'subscription.trial15d': '15 günlük deneme',
  'subscription.billingDesc': 'Fatura bilgilerinizi girin ve ödeme adımına geçin',
  'subscription.savedBillingInfo': '📄 Kaydedilmiş fatura bilgileriniz',
  'subscription.enterBillingInfo': '📄 Lütfen fatura bilgilerinizi doldurunuz',
  'subscription.billingAutoSave': '💾 Bilgileriniz otomatik olarak kaydedilir ve bir dahaki ödemenizde doldurulur',
  'subscription.billingLangLabel': 'Fatura Dili',
  'subscription.taxOffice': 'Vergi Dairesi',
  'subscription.saveInfoBtn': '💾 Bilgileri Kaydet',
  'subscription.saveInfoHint': 'Bir sonraki ödemede otomatik doldurulacaktır',
  'subscription.billingInfoSaved': '✅ Fatura bilgileri kaydedildi',
  'subscription.cardInfoTitle': 'Kart Bilgileri Ödeme Sayfasında Alınacak',
  'subscription.subInfoTitle': '📋 Abonelik Bilgileri',
  'subscription.subIsMonthly': '✅ Bu bir aylık abonelik işlemidir.',
  'subscription.subIsYearly': '✅ Bu bir yıllık abonelik işlemidir.',
  'subscription.autoRenewInfo': '🔄 Aboneliğiniz otomatik olarak yenilenir. Yenileme öncesinde e-posta ile bildirim alacaksınız.',
  'subscription.cardAtPayment': '💳 Ödeme, ödeme sayfasında kart bilgileriniz ile gerçekleştirilecektir.',
  'subscription.cancelAnytime': 'ℹ️ Aboneliği istediğiniz zaman iptal edebilirsiniz.',
  'subscription.extendSubBtn': '💳 Aboneliği Uzat',
  'subscription.switchPlan': '💳 Pakete Geç',
  'subscription.changePlan': '💳 Değiştir',
  'subscription.switchPlanIntl': '🏓 Pakete Geç',
  'subscription.changePlanIntl': '🏓 Değiştir',
  'subscription.yearlyFreeNote': '🎉 Yıllık ödeme ile 2 ay bedava!',
  'subscription.yearlySavings': '💡 Yıllık ödeme ile %17 tasarruf edin',
  'subscription.planWord': 'Planı',
  'subscription.purchasePlanTitle': '{name} Planı Satın Alma',
  'subscription.totalAmountLabel': 'Toplam Tutar',
  'subscription.extendedBy1m': '1 ay uzatılacak',
  'subscription.extendedBy1y': '1 yıl uzatılacak',

  // Settings receipt preview
  'settings.previewItem1': 'Ürün 1',
  'settings.previewItem2': 'Ürün 2',
  'settings.previewTotal': 'TOPLAM',
  'settings.footerPlaceholder': 'Alt Bilgi Mesajı',
  'settings.receiptNote': 'Fiş Notu',

  // Charts
  'charts.revenue': 'Ciro',
  'charts.orders': 'Sipariş',
  'charts.pieces': 'Parça Sayısı',
  'charts.receipts': 'Fiş Sayısı',
  'charts.loadError': 'Veriler yüklenemedi',
  'charts.graphicReports': 'Grafik Raporlar',
  'charts.totalRevenue': 'Toplam Ciro',
  'charts.totalItems': 'Toplam Parça',
  'charts.totalReceipts': 'Toplam Fiş',
  'charts.cashCard': 'Nakit + Kredi Kartı',
  'charts.regDelivery': '(Kayıt + Teslim)',
  'charts.collectionSummary': 'Tahsilat Özeti',
  'charts.cashCardAtReg': '💵 Nakit/Kart (Kayıtta):',
  'charts.cashCardAtDel': '💵 Nakit/Kart (Teslimde):',
  'charts.currentCollections': '📋 Cari Tahsilat:',
  'charts.total': 'Toplam',
  'charts.noData': 'Bu dönemde veri bulunamadı',
  'charts.selectPeriod': 'Farklı bir dönem seçin',
  'charts.dailyRevenue': 'Günlük Ciro Grafiği',
  'charts.dailyItems': 'Günlük Parça Sayısı Grafiği',
  'charts.top10Customers': 'En Çok Ciro Yapan 10 Müşteri',
  'charts.customer': 'Müşteri',
  'charts.itemCount': 'Parça Sayısı',
  'charts.branchRevenue': 'Şube Bazlı Ciro',
  'charts.periodSuffix': 'dönemi',
  'reportsList.registeredThisPeriod': '📝 Bu Dönemde Kayıt Edilen ({count} fiş)',
  'reportsList.deliveredThisPeriod': '📦 Önceden Kayıt, Bu Dönemde Teslim ({count} fiş)',
  'reportsList.created': 'Oluşturma',
  'reportsList.delivered': 'Teslim',
  'customerStatement.selectDateRange': 'Tarih Aralığı Seçin',
  'customerStatement.thisMonth': 'Bu Ay',
  'customerStatement.lastMonth': 'Geçen Ay',
  'customerStatement.allTime': 'Tüm Zamanlar',
  'customerStatement.startDate': 'Başlangıç Tarihi',
  'customerStatement.endDate': 'Bitiş Tarihi',
  'customerStatement.printPDF': 'Ekstreyi Bas (PDF)',
  'customerStatement.title': 'CARİ HESAP EKSTRESİ',
  'customerStatement.customerName': 'Müşteri Adı',
  'customerStatement.phone': 'Telefon',
  'customerStatement.address': 'Adres',
  'customerStatement.openingBalance': 'Açılış Bakiyesi',
  'customerStatement.closingBalance': 'Kapanış Bakiyesi',
  'customerStatement.description': 'Açıklama',
  'customerStatement.type': 'Tür',
  'customerStatement.debit': 'Borç',
  'customerStatement.credit': 'Alacak (Tahsil Edilen)',
  'customerStatement.total': 'TOPLAM',
  'customerStatement.cancelled': 'İPTAL',
  'customerStatement.payment': 'Ödeme',
  'customerStatement.items': 'ürün',
  'customerStatement.noTransactions': 'Seçilen tarih aralığında hareket bulunmamaktadır.',
  'customerStatement.statementDate': 'Ekstre Tarihi',
  'tailoring.subtitle': 'Terzi işlemlerinin fiyatlarını buradan güncelleyebilirsiniz',
  'tailoring.addNewDescription': 'Özel bir terzi işlemi türü ekleyin',
  'tailoring.operationNamePlaceholder': 'Örn: Özel Dikiş',
  'tailoring.add': 'Ekle',
  'tailoring.savePrices': 'Fiyatları Kaydet',
  'tailoring.default': 'Varsayılan',
  'tailoring.infoTitle': 'Bilgi',
  'tailoring.info1': 'Fiyatları değiştirdikten sonra "Fiyatları Kaydet" butonuna tıklayın',
  'tailoring.info2': '"Yeni İşlem" butonu ile özel terzi işlemi türleri ekleyebilirsiniz',
  'tailoring.info3': 'Eklediğiniz özel işlemleri çöp kutusu ikonu ile silebilirsiniz',
  'tailoring.info4': 'Bu fiyatlar sipariş oluştururken terzi hizmeti seçildiğinde kullanılır',
  'tailoring.info5': 'Her terzi işlemi için ayrı fiyat belirleyebilirsiniz',
  'tailoring.info6': 'Fiyatlar müşteri sepetine eklenirken otomatik hesaplanır',

  'hardware.title': 'Donanım Mağazası',
  'hardware.subtitle': 'Fiş yazıcıları, etiket yazıcıları ve Caller ID cihazları',
  'hardware.cart': 'Sepet',
  'hardware.infoTitle': 'Bilgilendirme',
  'hardware.infoText': 'Bu donanımlar şu an için sadece Türkiye\'de satın alınabilir. Diğer ülkeler için bilgi amaçlı olarak listelenmiştir.',
  'hardware.myCart': 'Sepetim',
  'hardware.cartEmpty': 'Sepet boş',
  'hardware.vatSuffix': '+ KDV',
  'hardware.total': 'Toplam',
  'hardware.checkout': 'Ödemeye Geç',
  'hardware.receiptPrinters': 'Fiş Yazıcıları',
  'hardware.receiptPrintersSubtitle': '80mm termal yazıcılar, otomatik kesici',
  'hardware.compatibilityTitle': 'CleandySoft Uyumluluk',
  'hardware.receiptCompatText': 'Tüm 80mm termal ve kesicisi olan yazıcılar ile çalışır.',
  'hardware.labelPrinters': 'Etiket Yazıcıları',
  'hardware.labelPrintersSubtitle': 'Nokta vuruşlu yazıcılar, 76mm/57mm (Epson TM-U220, Bixolon SRP-270)',
  'hardware.testedModels': 'Test Edilen Modeller',
  'hardware.labelCompatText': 'Epson TM-U220 ve Bixolon SRP-270 modelleri için test edilmiştir. Farklı marka veya modellerde sorunlar yaşanabilir.',
  'hardware.callerIdTitle': 'Arayan Kimliği (Caller ID)',
  'hardware.callerIdSubtitle': 'Müşteri aramalarında numara tanıma',
  'hardware.compatibilityNote': 'Uyumluluk Notu',
  'hardware.callerIdCompatText': 'Sadece CIDShow 2 Hatlı model için test edilmiştir. Farklı marka veya modeller çalışabilir ancak garanti edilmez.',
  'hardware.barcodeScanners': 'Barkod Okuyucular',
  'hardware.barcodeScannerSubtitle': 'USB barkod ve karekod okuyucular',
  'hardware.barcodeCompatText': 'Tüm 2D barkod okuyucular CleandySoft ile çalışabilir. USB HID modunda çalışanlar otomatik desteklenir.',
  'hardware.driverDownloads': 'Sürücü ve Yazılım İndirme',
  'hardware.driverDownloadsText': 'Yazıcınızı bağlamadan önce uygun sürücüyü indirmeniz önerilir.',
  'hardware.onlyTurkey': 'Bu ürün sadece Türkiye\'de satın alınabilir',
  'hardware.addedToCart': 'Sepete eklendi!',
  'hardware.available': 'Satışta',
  'hardware.info': 'Bilgi',
  'hardware.features': 'Özellikler',
  'hardware.addToCart': 'Sepete Ekle',
  'hardware.infoOnly': 'Bilgi Amaçlı',

  // Ön eksiz genel anahtarlar (Ürünler/Şablonlar pencerelerinde ham anahtar basılıyordu)
  'cancel': 'İptal',
  'save': 'Kaydet',
  'update': 'Güncelle',
  'create': 'Oluştur',
  'loading': 'Yükleniyor...',
  'back': 'Geri',
  'smsSettingsRequired': 'Test SMS göndermeden önce yukarıdaki SMS ayarlarını yapılandırıp kaydedin',
};